<template>
  <div id="app">
    <!-- 登录页面、注册页面、充值页面：独立显示 -->
    <router-view
        v-if="$route.path === '/login' || $route.path === '/register' || $route.path === '/recharge'"></router-view>

    <!-- 主应用布局 -->
    <template v-else>
      <aside class="sidebar" :class="{ collapsed: isCollapsed }">
        <div class="sidebar-logo">
          <div class="logo-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect x="2" y="2" width="28" height="28" rx="6" stroke="var(--accent)" stroke-width="1.5"/>
              <path d="M10 12L16 8L22 12V22L16 26L10 22V12Z" stroke="var(--accent)" stroke-width="1.5"/>
              <circle cx="16" cy="16" r="3" fill="var(--accent)" opacity="0.6"/>
            </svg>
          </div>
          <span v-show="!isCollapsed" class="logo-text">MULTIFA<span class="accent">CED</span></span>
        </div>

        <nav class="sidebar-nav">
          <router-link v-for="item in navItems" tag="div" :key="item.path" :to="item.path" class="nav-item"
                       :class="{ active: isActive(item.path) }">
            <span class="nav-icon" v-html="item.icon"></span>
            <span v-show="!isCollapsed" class="nav-label">{{ item.label }}</span>
            <span v-if="isActive(item.path)" class="nav-indicator"></span>
          </router-link>

          <div id="vip-time" v-if="userInfo && !isCollapsed">
            <div>到期时间：{{ userInfo?.vip_time_text }}</div>
          </div>
        </nav>

        <div class="sidebar-bottom">
          <button class="collapse-btn" @click="isCollapsed = !isCollapsed" :title="isCollapsed ? '展开' : '收起'">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                 :style="{ transform: isCollapsed ? '' : 'rotate(180deg)' }">
              <path d="M6 3L10 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
          <div v-show="!isCollapsed" class="sidebar-version">v1.0.0</div>
        </div>
      </aside>

      <div class="main-area">
        <header class="app-header">
          <div class="header-left">
            <div class="breadcrumb">
              <span class="breadcrumb-item">{{ currentPage }}</span>
              <span class="breadcrumb-sep">/</span>
              <span class="breadcrumb-active">MULTIFACED</span>
            </div>
          </div>
          <div class="header-right">
            <div class="header-stat">
              <span class="pulse-dot"></span>
              <span class="stat-text">MULTIFACED</span>
            </div>
            <div class="header-time">{{ currentTime }}</div>
            <div class="header-divider"></div>
            <!-- 用户头像 -->
            <div class="user-avatar" title="管理员">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="7" r="4" stroke="currentColor" stroke-width="1.3"/>
                <path d="M3 18c0-3.87 3.13-7 7-7s7 3.13 7 7" stroke="currentColor" stroke-width="1.3"
                      stroke-linecap="round"/>
              </svg>
            </div>
            <!-- 窗口控制 -->
            <button class="win-btn" title="最小化" @click="eSend('windows','minimize')">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <rect x="2" y="6" width="10" height="1.5" rx="0.75" fill="currentColor"/>
              </svg>
            </button>
            <button class="win-btn win-close" title="关闭" @click="eSend('windows','close')">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 3L11 11M11 3L3 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </header>

        <main class="main-content">
          <!--        style="position: fixed; top: -9999px; left: -9999px; width: 1920px; height: 1080px;"-->

          <canvas
              ref="globalCanvas"
              class="globalCanvas"
          ></canvas>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </main>

      </div>
    </template>

    <!-- 全局视频播放器（始终隐藏） -->
    <!--    <zwplayer style="display: none"
                  :murl="videoUrl"
                  :autoplay="true"
                  :localPlayback="true"
                  @onready="onPlayerReady"
                  ref="globalVideo"
                  crossorigin="anonymous"
        />-->

    <div id="globalVideo" style="display: none" ref="globalVideo"></div>
    <div id="overlayVideoPlayer" style="display: none" ref="overlayVideoPlayer"></div>

    <!-- 遮罩视频层 (始终显示) -->
    <!--    <zwplayer
            style="display: none"
            :murl="overlayVideoUrl"
            :autoplay="true"
            :localPlayback="true"
            @onready="onOverlayPlayerReady"
            ref="overlayVideoPlayer"
            crossorigin="anonymous"
        ></zwplayer>-->

    <!-- 真实摄像头视频层 (始终隐藏，用于全局渲染) -->
    <video
        ref="realCameraVideoElement"
        style="display: none;"
        playsinline
        autoplay
        muted
    ></video>

    <!-- 全局 Toast 提示 -->
    <Transition name="toast">
      <div v-if="toast.show" class="toast-notification" :class="toast.type">
        <div class="toast-content">
          <svg v-if="toast.type === 'success'" width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          {{ toast.message }}
        </div>
      </div>
    </Transition>

    <CyberModal
        :visible="modalVisible"
        :title="modalTitle"
        :message="modalMessage"
        @close="modalVisible = false"
        @confirm="handleModalConfirm"
    />

  </div>
</template>

<script>
import DPlayer from 'dplayer';
import {delay, showToast} from "@/utils/function";
import http from "@/utils/http";
import flvjs from 'flv.js'
import CyberModal from "@/components/CyberModal.vue";

export default {
  name: 'App',
  components: {CyberModal},

  provide() {
    return {

      sendConfigToBackend: this.sendConfigToBackend,
      getUserInfo: this.getUserInfo,
      wsSocket: null,
      setGlobalVideoSrc: this.setGlobalVideoSrc,
      playGlobalVideo: this.playGlobalVideo,
      pauseGlobalVideo: this.pauseGlobalVideo,
      setGlobalVideoCurrentTime: this.setGlobalVideoCurrentTime,
      setGlobalVideoMuted: this.setGlobalVideoMuted,
      setGlobalVideoLoop: this.setGlobalVideoLoop,
      getGlobalVideo: this.getGlobalVideo,
      getGlobalAudio: this.getGlobalAudio,
      getGlobalGainNode: this.getGlobalGainNode,
      updateAllVideosAudioSinkId: this.updateAllVideosAudioSinkId,
      setOverlayVideoSrc: this.setOverlayVideoSrc,
      playOverlayVideo: this.playOverlayVideo,
      pauseOverlayVideo: this.pauseOverlayVideo,
      getOverlayVideo: this.getOverlayVideo,
      globalCanvasState: this.globalCanvasState,
      updateGlobalCanvasState: this.updateGlobalCanvasState,
      syncCanvasToTarget: this.syncCanvasToTarget,
      startRealCamera: this.startRealCamera,
      stopRealCamera: this.stopRealCamera,
      enumerateRealCameraDevices: this.enumerateRealCameraDevices,
      startShake: this.startShake,
      stopShake: this.stopShake,
      startColorAdjust: this.startColorAdjust,
      stopColorAdjust: this.stopColorAdjust,
      startCameraMotion: this.startCameraMotion,
      stopCameraMotion: this.stopCameraMotion,
      startAIRecomposition: this.startAIRecomposition,
      stopAIRecomposition: this.stopAIRecomposition,
      startOverlayAnimation: this.startOverlayAnimation,
      stopOverlayAnimation: this.stopOverlayAnimation,
      // 遮罩视频播放列表相关
      setOverlayPlaylist: this.setOverlayPlaylist,
      setOverlayPlayMode: this.setOverlayPlayMode,
      // 直播视频播放列表相关
      setPlaylist: this.setPlaylist,
      setPlayMode: this.setPlayMode,
      disconnectWebSocket: this.disconnectWebSocket,
      connectWebSocket: this.connectWebSocket,
      sendCanvasFrame: this.sendCanvasFrame,
      eSend: this.eSend,
      showGlobalToast: this.showGlobalToast
    }
  },
  data() {
    return {
      modalVisible: false,
      modalTitle: '系统提示',
      modalMessage: '',
      redirectAfterConfirm:null,
      globalVideo: null,
      overlayVideoPlayer: null,
      videoUrl: "",
      audioCtx: null,
      overlayVideoUrl: "",
      currentTime: '',
      isCollapsed: false,
      // 音频输出设备ID
      currentAudioDeviceId: '',
      // 装饰图片缓存
      decorationImageCache: {},
      pageNames: {
        '/': 'MULTIFACED',
        '/audio': 'audio_dedup',
        '/hot-sale': 'hot_sale_effects',
        '/smart-overlay': 'smart_overlay',
        '/live-float': 'live_floating_screen',
        '/dynamic-title': 'dynamic_title',
        '/live-stickers': 'live_stickers',
        '/tasks': 'task_manager',
      },

      navItems: [
        {
          path: '/',
          label: '视频去重',
          icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2" y="2" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.3"/><rect x="11" y="2" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.3"/><rect x="2" y="11" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.3"/><rect x="11" y="11" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.3"/></svg>'
        },
        {
          path: '/audio',
          label: '音频去重',
          icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="3" y="6" width="3" height="8" rx="1" stroke="currentColor" stroke-width="1.3"/><rect x="8" y="4" width="3" height="12" rx="1" stroke="currentColor" stroke-width="1.3"/><rect x="13" y="7" width="3" height="6" rx="1" stroke="currentColor" stroke-width="1.3"/></svg>'
        },
        {
          path: '/hot-sale',
          label: '热卖特效',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>'
        },
        {
          path: '/smart-overlay',
          label: '智能贴片',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"/><rect x="2" y="14" width="20" height="8" rx="2" ry="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>'
        },
        {
          path: '/dynamic-title',
          label: '动态标题',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7V4h16v3"/><path d="M9 20h6"/><path d="M12 4v16"/></svg>'
        }
      ],

      // Canvas 渲染相关状态
      globalCanvasState: {
        // 特效相关
        effects: {
          enabled: false,
          type: '字幕雨',
          playMode: 'fixed',
          opacity: 100
        },
        effectsParticles: [],
        effectsTime: 0,
        lastEffectType: null,
        effectsSwitchTimer: null,
        effectsList: ['字幕雨', '雪花', '星空', '动态杂点', '粒子线条', '彩色光斑', '动态扫描线', '混沌透视重塑', '色彩偏移', '边缘流光', 'AI像素重组'],
        currentEffectIndex: 0,

        // 调色相关
        colorAdjust: {
          enabled: false,
          mode: 'micro',
          adjustStart: 30,
          adjustEnd: 60
        },
        colorAdjustState: {
          value: {
            brightness: 1,
            contrast: 1,
            saturation: 1,
            hueRotate: 0
          }
        },

        // 运镜相关
        cameraMotion: {
          enabled: false,
          mode: 'micro',
          motionStart: 10,
          motionEnd: 20
        },
        currentCameraTransform: {
          value: {
            scale: 1,
            x: 0,
            y: 0
          }
        },
        cameraMotionTimer: null,
        isCurrentlyMoving: false,
        cameraMotionTimeOffset: 0,  // 新增：运镜时间偏移，保证连续
        lastCameraMotionRealEndTime: 0,  // 新增：上次运镜结束的真实时间
        lastCameraMotionTime: 0,  // 新增：上次运镜结束的time变量值
        cameraMotionIntensityTransition: {  // 新增：运镜强度切换过渡
          isTransitioning: false,
          startTime: 0,
          duration: 600,  // 过渡时间600ms
          fromScaleRange: 0,
          fromMoveRange: 0,
          toScaleRange: 0,
          toMoveRange: 0
        },
        // 运镜动画状态
        cameraMotionAnimState: {
          isAnimating: false,
          startTime: 0,
          duration: 1200,  // 动画时长1200ms，更自然
          targetEnabled: false,
          from: {
            scale: 1,
            x: 0,
            y: 0
          },
          to: {
            scale: 1,
            x: 0,
            y: 0
          },
          current: {
            scale: 1,
            x: 0,
            y: 0
          },
          // 新增：运镜强度切换动画
          isIntensityAnimating: false,
          intensityStartTime: 0,
          intensityDuration: 800,
          intensityFromScale: 1,
          intensityToScale: 1
        },

        // 抖动相关
        shake: {
          enabled: false,
          mode: 'micro',
          intervalStart: 5,
          intervalEnd: 10
        },
        isCurrentlyShaking: false,
        shakeTimer: null,  // 抖动定时器，参考运镜的 cameraMotionTimer
        // 抖动动画状态
        shakeAnimState: {
          isAnimating: false,
          startTime: 0,
          duration: 800,  // 动画时长800ms
          targetEnabled: false,
          fromScale: 1,
          toScale: 1,
          currentScale: 1
        },

        // AI重组相关
        aiRecomposition: {
          enabled: false,
          mode: 'micro',
          intervalStart: 20,
          intervalEnd: 40
        },
        currentAIState: {
          value: {
            scale: 1,
            rotate: 0,
            flip: false,
            brightness: 1,
            contrast: 1
          }
        },
        aiTransform: {  // AI重组的独立变换
          scale: 1,
          x: 0,
          y: 0
        },
        aiAnimState: {  // AI重组动画状态
          isAnimating: false,
          startTime: 0,
          duration: 2000,  // 动画时长2000ms，更慢更自然
          from: {
            scale: 1,
            rotate: 0,
            x: 0,
            y: 0,
            brightness: 1,
            contrast: 1,
            saturation: 1,
            hueRotate: 0
          },
          to: {
            scale: 1,
            rotate: 0,
            x: 0,
            y: 0,
            brightness: 1,
            contrast: 1,
            saturation: 1,
            hueRotate: 0
          },
          current: {  // 当前动画中的状态
            scale: 1,
            rotate: 0,
            x: 0,
            y: 0,
            brightness: 1,
            contrast: 1,
            saturation: 1,
            hueRotate: 0
          }
        },
        // 特效定时器
        effectTimers: {},

        // 视频相关
        material: {
          volume: 100,
          playMode: 'sequence'
        },
        overlay: {
          opacity: 100,
          playMode: 'sequence'  // sequence 或 random
        },
        // 遮罩视频动画相关
        overlayAnimation: {
          enabled: true,  // 默认开启
          scale: 1,
          rotate: 0,
          targetScale: 1,
          targetRotate: 0
        },
        overlayAnimState: {
          isAnimating: false,
          startTime: 0,
          duration: 3000,  // 3秒动画时长
          from: {
            scale: 1,
            rotate: 0
          },
          to: {
            scale: 1,
            rotate: 0
          },
          current: {
            scale: 1,
            rotate: 0
          }
        },
        overlayAnimTimer: null,
        // 直播视频播放列表相关
        playlist: [],
        currentIndex: 0,
        // 遮罩视频播放列表相关
        overlayPlaylist: [],
        overlayCurrentIndex: 0,
        // 图片遮罩相关
        imageOverlay: {
          enabled: false,
          path: '',
          opacity: 100,
          images: [],
          currentImage: '',
          currentIndex: 0
        },
        // 图片遮罩 Image 对象缓存
        imageOverlayElement: null,

        // 虚拟摄像头相关
        isVirtualCameraLive: false,
        cameraSettings: {
          name: 'Unity Video Capture'
        },

        // 真实摄像头相关
        realCamera: {
          enabled: false,
          position: {x: 100, y: 100},
          size: {width: 320, height: 240},
          zIndex: 10,
          opacity: 100
        },
        realCameraVideo: null,
        realCameraDevices: [],
        realCameraStream: null,
        realCameraOriginalWidth: 0,
        realCameraOriginalHeight: 0,

        // 热卖特效相关
        hotSaleState: {
          hotSaleImage: null,
          inventoryImage: null,
          hotSalePopping: false,
          hotSalePoppingStartTime: 0,
          lastHotSaleCount: 0,
          inventoryPopping: false,
          inventoryPoppingStartTime: 0,
          lastInventoryCount: 0,
          purchaseVisible: false,
          textScrollOffset: 0,
          marqueeOffset: 0,
          hotSaleStartTime: Date.now(),
          inventoryStartTime: Date.now(),
          purchaseStartTime: Date.now()
        },

        // 智能贴片相关
        smartOverlayState: {
          currentRotationText: '爆款推荐',
          instantStickerActive: false,
          instantStickerValue: '',
          rotationTimer: null,
          rotationTimerId: 0
        },

        // 手机转播相关配置
        phoneBroadcast: {
          enabled: false,
          serverUrl: '',
          port: '1935',
          quality: '720p',
          frameRate: 30,
          bitrate: '4000'
        },

        // WebSocket 相关
        wsSocket: null,
        wsConnected: false,
        isSendingFrame: false,
        canvasSendInterval: null
      },

      // Canvas 引用和渲染相关
      videoCtx: null,
      videoRenderFrameId: null,

      // Toast 相关
      toast: {
        show: false,
        message: '',
        type: 'success'
      },
      toastTimer: null
    }
  },
  computed: {
    currentPage() {
      return this.pageNames[this.$route.path]
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  watch: {
    // 监听运镜开关变化，启动动画
    'globalCanvasState.cameraMotion.enabled': {
      handler: function (newVal) {
        this.startCameraMotionTransition(newVal)
        if (newVal) {
          this.scheduleCameraMotion()
        }
      }
    },
    // 深度监听运镜状态变化，重新调度
    'globalCanvasState.cameraMotion': {
      handler: function () {
        if (this.globalCanvasState.cameraMotion.enabled) {
          this.scheduleCameraMotion()
        }
      },
      deep: true
    },
    // 监听抖动开关变化，启动动画
    'globalCanvasState.shake.enabled': {
      handler: function (newVal) {
        this.startShakeTransition(newVal)
        if (newVal) {
          this.scheduleShake()
        }
      }
    },
    // 深度监听抖动状态变化，重新调度
    'globalCanvasState.shake': {
      handler: function () {
        if (this.globalCanvasState.shake.enabled) {
          this.scheduleShake()
        }
      },
      deep: true
    },
    // 深度监听调色状态变化，重新调度
    'globalCanvasState.colorAdjust': {
      handler: function () {
        if (this.globalCanvasState.colorAdjust.enabled) {
          this.scheduleColorAdjust()
        }
      },
      deep: true
    },
    // 深度监听AI重组状态变化，重新调度
    'globalCanvasState.aiRecomposition': {
      handler: function () {
        if (this.globalCanvasState.aiRecomposition.enabled) {
          this.scheduleAIRecomposition()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getNotice();

    this.initPlay();
    chrome?.webview?.addEventListener('message', async ({data}) => {
      const type = data.type;
      switch (type) {
        case "exit":
          this.sendConfigToBackend("stop")
          break;
        case "setUrl":
          if (data.data.type == 'play') {
            this.setGlobalVideoSrc(data.data.url);
          } else {
            this.setOverlayVideoSrc(data.data.url);

          }

          this.playGlobalVideo();

          break;
        case "setServerUrl":

          this.$store.commit("setServerUrl", data.data)

          break;
      }
    });
    const token = localStorage.getItem("token");
    if (token) {

      this.eSend("start", token);

      this.$store.commit("setToken", token);
    }
    this.heartbeat();
    this.getUserInfo();
    // 清除 localStorage 中可能保存的旧热卖配置，确保所有开关默认关闭
    localStorage.removeItem('hot_sale_params')
    this.startVideoRender()
    this.loadHotSaleImages()
    // 初始化摄像头视频元素引用
    this.$nextTick(() => {
      this.globalCanvasState.realCameraVideo = this.$refs.realCameraVideoElement
    })
    // 如果某些效果已经开启，自动启动它们
    this.$nextTick(() => {
      if (this.globalCanvasState.shake.enabled) {
        this.startShake()
      }
      if (this.globalCanvasState.colorAdjust.enabled) {
        this.startColorAdjust()
      }
      if (this.globalCanvasState.cameraMotion.enabled) {
        this.startCameraMotion()
      }
      if (this.globalCanvasState.aiRecomposition.enabled) {
        this.startAIRecomposition()
      }
      // 启动遮罩视频动画
      if (this.globalCanvasState.overlayAnimation.enabled) {
        this.startOverlayAnimation()
      }
    })

    // 启动全局音频随机化计时器
    this.$store.dispatch('startGlobalAudioRandomizer')

    // 挂载全局实例，方便直接调用
    window.appInstance = this
  },
  methods: {
    handleModalConfirm() {
      if (this.redirectAfterConfirm) {
        this.redirectAfterConfirm()
      }
    },
    showModal(title, message, callback = null) {
      this.modalTitle = title
      this.modalMessage = message
      this.redirectAfterConfirm = callback
      this.modalVisible = true
    },
    async getNotice(){
      const res=await http.get("api/config/getNotice");

      if(res.data){
        this.showModal("公告",res.data,function (){

        });

      }




    },

    initPlay() {
      this.globalVideo = new DPlayer({
        container: document.getElementById('globalVideo'),
        autoplay: true,
        mutex: false,
        video: {
          type: 'auto',
          url: '',
        },
      });


      // 添加直播视频 ended 事件监听
      this.$nextTick(async () => {
        const globalVideo = this.getGlobalVideo();
        if (globalVideo) {
          globalVideo.addEventListener('ended', this.handleVideoEnded)
          globalVideo.addEventListener('error', this.handleVideoError)
        }
      })


      this.overlayVideoPlayer = new DPlayer({
        container: document.getElementById('overlayVideoPlayer'),
        autoplay: true,
        mutex: false,
        video: {
          type: 'auto',
          url: '',
        },
      });

      this.$nextTick(async () => {
        const overlayVideo = this.getOverlayVideo();
        if (overlayVideo) {
          overlayVideo.addEventListener('ended', this.handleOverlayVideoEnded)
          overlayVideo.addEventListener('error', this.handleOverlayVideoError)
        }
      })

    },

    showGlobalToast(message, type = 'success') {
      if (this.toastTimer) {
        clearTimeout(this.toastTimer)
      }

      this.toast.message = message
      this.toast.type = type
      this.toast.show = true

      this.toastTimer = setTimeout(() => {
        this.toast.show = false
      }, 3000)
    },

    async sendConfigToBackend(action = "", extraSettings = {}) {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 增加超时到 10 秒，防止启动驱动时超时中断

      // 自动根据当前访问地址确定后端地址，解决 127.0.0.1 vs localhost 跨域问题
      const backendBase = `http://127.0.0.1:3000`;

      // 获取视频预览容器的尺寸
      let previewWidth = 320, previewHeight = 240;
      const videoPreview = document.querySelector('.video-preview');
      if (videoPreview) {
        const rect = videoPreview.getBoundingClientRect();
        previewWidth = rect.width;
        previewHeight = rect.height;
      }

      try {
        console.log(`[发送指令] action: ${action}, isPlaying: ${this.isPlaying}`);
        const response = await fetch(`${backendBase}/start`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          keepalive: true,
          signal: controller.signal,
          body: JSON.stringify({
            drive_name: this.globalCanvasState.cameraSettings.name,
            action: action,
            token: this.$store.state.token
          })
        })
        clearTimeout(timeoutId);
        if (response.ok) return true;
        const errorData = await response.json().catch(() => ({message: '服务器响应异常'}));
        return errorData.message || '启动指令被服务器拒绝';
      } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
          console.warn('[请求] 后端响应超时，但指令可能已送达');
          return true; // 超时也认为成功，防止界面卡死
        }
        console.error('请求失败:', error)
        return '网络连接失败，请检查后端是否运行';
      }
    },

    eSend(type, data = {}) {
      try {
        window.chrome.webview.postMessage({type, data})
      } catch (e) {
      }
    },
    async heartbeat() {

      await http.get("api/user/heartbeat");

      await delay(5000);
      this.heartbeat();

    },
    async getUserInfo() {

      const res = await http.get("api/user/info");
      if (res.code == 200) {
        this.$store.commit("setUserInfo", res.data);
      }


    },


    // 辅助方法：获取运镜模式对应的强度范围
    getCameraMotionRanges(mode) {
      if (mode === 'micro') {
        return {scaleRange: 0.05, moveRange: 20}
      } else if (mode === 'medium') {
        return {scaleRange: 0.1, moveRange: 40}
      } else {
        return {scaleRange: 0.18, moveRange: 70}
      }
    },
    // 更新全局 Canvas 状态的方法，供子组件调用
    updateGlobalCanvasState(key, value) {
      // 如果是更新audioSettings，保存deviceId并更新视频音频输出
      if (key === 'audioSettings' && value.driver) {
        this.currentAudioDeviceId = value.driver;
        this.updateAllVideosAudioSinkId(value.driver);
      }

      // 如果是更新cameraMotion，检查mode是否变化
      if (key === 'cameraMotion') {
        const oldMode = this.globalCanvasState.cameraMotion.mode
        const newMode = value.mode

        if (oldMode !== newMode) {
          // 模式变化了，启动强度过渡动画
          const cmAnimState = this.globalCanvasState.cameraMotionAnimState
          const baseScale = 1.1

          cmAnimState.isIntensityAnimating = true
          cmAnimState.intensityStartTime = Date.now()
          cmAnimState.intensityFromScale = cmAnimState.current.scale
          cmAnimState.intensityToScale = baseScale

          // 过渡结束后关闭标志
          setTimeout(() => {
            cmAnimState.isIntensityAnimating = false
          }, cmAnimState.intensityDuration)
        }
      }

      this.$set(this.globalCanvasState, key, value)
    },

    // 更新所有视频的音频输出设备
    updateAllVideosAudioSinkId(deviceId) {
      try {

        // 更新主视频
        const globalVideo = this.getGlobalVideo();
        if (globalVideo && globalVideo.setSinkId) {
          globalVideo.setSinkId(deviceId).catch(e => {
            console.warn('[App] 设置主视频音频输出失败:', e);
          });
        }

        // 更新遮罩视频
        const overlayVideo = this.getOverlayVideo();
        if (overlayVideo && overlayVideo.setSinkId) {
          overlayVideo.setSinkId(deviceId).catch(e => {
            console.warn('[App] 设置遮罩视频音频输出失败:', e);
          });
        }

        // Web Audio 处理链输出设备，音频去重开启后声音会走 AudioContext.destination
        const audioContext = this.getGlobalAudio();
        if (audioContext && audioContext.setSinkId) {
          audioContext.setSinkId(deviceId).catch(e => {
            console.warn('[App] 设置音频处理链输出失败:', e);
          });
        }
      } catch (e) {
        console.warn('[App] 更新音频输出设备失败:', e);
      }
    },

    // 将 globalCanvas 的画面同步到目标 canvas
    syncCanvasToTarget(targetCanvas) {
      const sourceCanvas = this.$refs.globalCanvas
      if (!sourceCanvas || !targetCanvas) return

      const sourceCtx = sourceCanvas.getContext('2d')
      const targetCtx = targetCanvas.getContext('2d')

      if (!sourceCtx || !targetCtx) return

      // 确保目标 canvas 尺寸和源一致
      if (targetCanvas.width !== sourceCanvas.width || targetCanvas.height !== sourceCanvas.height) {
        targetCanvas.width = sourceCanvas.width
        targetCanvas.height = sourceCanvas.height
      }

      // 直接绘制源 canvas 到目标 canvas
      targetCtx.drawImage(sourceCanvas, 0, 0)
    },

    // 初始化视频画布
    initVideoCanvas() {
      if (this.$refs.globalCanvas) {
        this.videoCtx = this.$refs.globalCanvas.getContext('2d')
      }
    },

    // 开始视频渲染循环
    startVideoRender() {
      if (this.videoRenderFrameId) {
        cancelAnimationFrame(this.videoRenderFrameId)
      }

      const render = () => {
        this.renderFrame()
        this.videoRenderFrameId = requestAnimationFrame(render)
      }

      render()
    },

    // 停止视频渲染循环
    stopVideoRender() {
      if (this.videoRenderFrameId) {
        cancelAnimationFrame(this.videoRenderFrameId)
        this.videoRenderFrameId = null
      }
    },

    // 渲染单帧
    renderFrame() {
      const globalVideo = this.getGlobalVideo();
      const overlayVideo = this.getOverlayVideo();
      const canvas = this.$refs.globalCanvas
      const ctx = this.videoCtx
      const state = this.globalCanvasState

      if (!ctx || !canvas) return

      // 设置画布尺寸
      let targetWidth = 1280
      let targetHeight = 720

      if (globalVideo && globalVideo.videoWidth > 0 && globalVideo.videoHeight > 0) {
        targetWidth = globalVideo.videoWidth
        targetHeight = globalVideo.videoHeight
      }

      if (canvas.width !== targetWidth || canvas.height !== targetHeight) {
        canvas.width = targetWidth
        canvas.height = targetHeight

        ctx.imageSmoothingEnabled = true
        ctx.imageSmoothingQuality = 'high'
      }

      const w = canvas.width
      const h = canvas.height

      // 1. 清除画布（填充为黑色）
      ctx.fillStyle = '#000000'
      ctx.fillRect(0, 0, w, h)

      // 2. 准备滤镜
      let filter = ''

      if (state.aiRecomposition.enabled) {
        // AI重组自己的滤镜（所有色彩调整都在这里）
        const ai = state.aiAnimState.current
        filter += `brightness(${ai.brightness}) contrast(${ai.contrast}) saturate(${ai.saturation}) hue-rotate(${ai.hueRotate}deg) `
      }

      if (state.colorAdjust.enabled) {
        // 实时调色独立的滤镜
        filter += `brightness(${state.colorAdjustState.value.brightness}) contrast(${state.colorAdjustState.value.contrast}) saturate(${state.colorAdjustState.value.saturation}) hue-rotate(${state.colorAdjustState.value.hueRotate}deg) `
      }

      ctx.filter = filter

      // 3. 应用变换（运镜、抖动、AI重组）
      ctx.save()

      let scale = 1
      let x = 0
      let y = 0
      let shakeX = 0
      let shakeY = 0
      let aiScale = 1
      let aiX = 0
      let aiY = 0
      let aiRotate = 0
      let aiBrightness = 1
      let aiContrast = 1
      let aiSat = 1
      let aiHue = 0

      // 运镜动画处理
      const cmAnimState = state.cameraMotionAnimState

      // 1. 首先处理强度切换动画（优先级最高）
      if (cmAnimState.isIntensityAnimating) {
        const now = Date.now()
        const elapsed = now - cmAnimState.intensityStartTime
        const t = Math.min(elapsed / cmAnimState.intensityDuration, 1)
        const easeT = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2

        // 先稍微放大一点，再平稳过渡，让变化更明显
        const midScale = cmAnimState.intensityFromScale + 0.02
        const scale1 = cmAnimState.intensityFromScale + (midScale - cmAnimState.intensityFromScale) * (easeT * 2)
        const scale2 = midScale + (cmAnimState.intensityToScale - midScale) * ((easeT - 0.5) * 2)

        if (easeT <= 0.5) {
          scale = scale1
        } else {
          scale = scale2
        }

        x = cmAnimState.current.x
        y = cmAnimState.current.y

        cmAnimState.current.scale = scale
        cmAnimState.current.x = x
        cmAnimState.current.y = y
      }
      // 2. 然后处理开关切换动画
      else if (cmAnimState.isAnimating) {
        const now = Date.now()
        const elapsed = now - cmAnimState.startTime
        const t = Math.min(elapsed / cmAnimState.duration, 1)

        // 缓动函数 - easeInOut
        const easeT = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2

        // 插值计算
        cmAnimState.current.scale = cmAnimState.from.scale + (cmAnimState.to.scale - cmAnimState.from.scale) * easeT
        cmAnimState.current.x = cmAnimState.from.x + (cmAnimState.to.x - cmAnimState.from.x) * easeT
        cmAnimState.current.y = cmAnimState.from.y + (cmAnimState.to.y - cmAnimState.from.y) * easeT

        // 应用动画状态
        scale = cmAnimState.current.scale
        x = cmAnimState.current.x
        y = cmAnimState.current.y

        // 动画结束
        if (t >= 1) {
          cmAnimState.isAnimating = false

          // 如果是开启运镜，调整timeOffset，让运镜的初始值和动画结束时一致，避免跳变
          if (cmAnimState.targetEnabled) {
            // 我们希望运镜的初始scale是baseScale，也就是sin(...) = -1
            // 运镜公式：scale = baseScale + (Math.sin(time * 0.5) + 1) / 2 * scaleRange
            // 要让这一项为0 → sin(time * 0.5) = -1 → time * 0.5 = 3π/2 → time = 3π
            const targetTime = 3 * Math.PI
            state.cameraMotionTimeOffset = (Date.now() / 1000) - targetTime
            state.lastCameraMotionRealEndTime = 0 // 重置，因为开始了新的运镜
          }
        }
      } else if (state.cameraMotion.enabled && state.isCurrentlyMoving) {
        // 只有isCurrentlyMoving为true时才运镜
        const time = (Date.now() / 1000) - state.cameraMotionTimeOffset
        const ranges = this.getCameraMotionRanges(state.cameraMotion.mode)
        const scaleRange = ranges.scaleRange
        const moveRange = ranges.moveRange

        const baseScale = 1.1
        scale = baseScale + (Math.sin(time * 0.5) + 1) / 2 * scaleRange
        const maxMove = (scale - 1) * Math.min(w, h) / 2
        x = 0
        const rawY = Math.cos(time * 0.4) * moveRange
        y = Math.max(-maxMove, Math.min(maxMove, rawY))
        state.currentCameraTransform.value = {scale, x, y}

        cmAnimState.current.scale = scale
        cmAnimState.current.x = x
        cmAnimState.current.y = y
      } else if (state.cameraMotion.enabled) {
        // 运镜功能开启，但不在运镜期间，保持最后状态不变
        scale = cmAnimState.current.scale
        x = cmAnimState.current.x
        y = cmAnimState.current.y
      } else {
        // 运镜关闭且无动画
        // 只有AI重组需要基础缩放
        if (state.aiRecomposition.enabled) {
          scale = 1.1
        } else {
          scale = cmAnimState.current.scale || 1
        }
      }

      // 抖动动画处理（在运镜之后）
      const shakeAnimState = state.shakeAnimState
      if (shakeAnimState.isAnimating) {
        const now = Date.now()
        const elapsed = now - shakeAnimState.startTime
        const t = Math.min(elapsed / shakeAnimState.duration, 1)
        const easeT = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2

        shakeAnimState.currentScale = shakeAnimState.fromScale + (shakeAnimState.toScale - shakeAnimState.fromScale) * easeT

        // 应用抖动的缩放，但要注意不能和运镜的缩放冲突！
        // 如果运镜已经开启（scale > 1），我们就不应用抖动的缩放了，避免重复放大
        if (!state.cameraMotion.enabled) {
          scale = shakeAnimState.currentScale
        }

        if (t >= 1) {
          shakeAnimState.isAnimating = false
        }
      } else if (state.shake.enabled && !state.cameraMotion.enabled) {
        // 抖动开启且运镜关闭时，应用基础缩放
        scale = 1.1
        shakeAnimState.currentScale = 1.1
      }

      // 抖动效果 - 有间隔的抖动
      if (state.shake.enabled && state.isCurrentlyShaking) {
        let shakeRange
        if (state.shake.mode === 'micro') {
          shakeRange = 1.5
        } else if (state.shake.mode === 'medium') {
          shakeRange = 4
        } else {
          shakeRange = 8
        }
        shakeX = (Math.random() - 0.5) * 2 * shakeRange
        shakeY = (Math.random() - 0.5) * 2 * shakeRange
      }

      // 处理AI重组动画
      if (state.aiRecomposition.enabled && state.aiAnimState.isAnimating) {
        const now = Date.now()
        const elapsed = now - state.aiAnimState.startTime
        const t = Math.min(elapsed / state.aiAnimState.duration, 1)

        // 缓动函数 - easeInOut
        const easeT = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2

        // 插值计算
        const from = state.aiAnimState.from
        const to = state.aiAnimState.to
        const current = state.aiAnimState.current

        current.scale = from.scale + (to.scale - from.scale) * easeT
        current.x = from.x + (to.x - from.x) * easeT
        current.y = from.y + (to.y - from.y) * easeT
        current.rotate = from.rotate + (to.rotate - from.rotate) * easeT
        current.brightness = from.brightness + (to.brightness - from.brightness) * easeT
        current.contrast = from.contrast + (to.contrast - from.contrast) * easeT
        current.saturation = from.saturation + (to.saturation - from.saturation) * easeT
        current.hueRotate = from.hueRotate + (to.hueRotate - from.hueRotate) * easeT

        // 更新变换状态
        aiScale = current.scale
        aiX = current.x
        aiY = current.y
        aiRotate = current.rotate

        // 动画结束
        if (t >= 1) {
          state.aiAnimState.isAnimating = false
        }
      } else if (state.aiRecomposition.enabled) {
        // 没有动画时，直接使用to状态或current状态
        aiScale = state.aiAnimState.current.scale
        aiX = state.aiAnimState.current.x
        aiY = state.aiAnimState.current.y
        aiRotate = state.aiAnimState.current.rotate
      }

      // AI重组缩放 - 注意，这里我们不再乘以currentAIState.value.scale，因为已经通过aiScale处理了
      if (state.aiRecomposition.enabled) {
        scale *= aiScale
        // 增加额外的安全缩放，确保不会漏黑边
        scale *= 1.05
        // 如果有旋转，再增加额外的安全缩放来防止旋转时漏黑边
        if (Math.abs(aiRotate) > 0) {
          const rotationSafety = 1 + Math.abs(aiRotate) / 90 * 0.15
          scale *= rotationSafety
        }
      }

      // 应用所有变换
      ctx.translate(w / 2, h / 2)

      if (state.aiRecomposition.enabled) {
        if (state.currentAIState.value.flip) {
          ctx.scale(-1, 1)
        }
        ctx.rotate((aiRotate * Math.PI) / 180)
      }

      ctx.scale(scale, scale)
      ctx.translate(x + shakeX + aiX, y + shakeY + aiY)
      ctx.translate(-w / 2, -h / 2)

      // 4. 绘制主视频
      if (globalVideo) {
        ctx.drawImage(globalVideo, 0, 0, w, h)
      }

      // 5. 绘制遮罩视频
      if (overlayVideo && overlayVideo.readyState >= 2) {
        ctx.save()
        ctx.globalAlpha = state.overlay.opacity / 100

        // 应用遮罩视频动画变换
        if (state.overlayAnimation.enabled) {
          // 处理动画插值
          let overlayScale = 1
          let overlayRotate = 0

          if (state.overlayAnimState.isAnimating) {
            const now = Date.now()
            const elapsed = now - state.overlayAnimState.startTime
            const t = Math.min(elapsed / state.overlayAnimState.duration, 1)

            // 缓动函数 - easeInOut
            const easeT = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2

            const from = state.overlayAnimState.from
            const to = state.overlayAnimState.to

            overlayScale = from.scale + (to.scale - from.scale) * easeT
            overlayRotate = from.rotate + (to.rotate - from.rotate) * easeT

            if (t >= 1) {
              state.overlayAnimState.isAnimating = false
            }
          } else {
            overlayScale = state.overlayAnimState.current.scale
            overlayRotate = state.overlayAnimState.current.rotate
          }

          // 应用变换到遮罩视频
          ctx.translate(w / 2, h / 2)
          ctx.rotate((overlayRotate * Math.PI) / 180)

          // 计算安全缩放，防止旋转时漏黑边
          let safeScale = overlayScale
          if (Math.abs(overlayRotate) > 0) {
            const rotationSafety = 1 + Math.abs(overlayRotate) / 90 * 0.15
            safeScale *= rotationSafety
          }
          safeScale *= 1.05  // 额外安全缩放

          ctx.scale(safeScale, safeScale)
          ctx.translate(-w / 2, -h / 2)
        }

        ctx.drawImage(overlayVideo, 0, 0, w, h)
        ctx.restore()
      }

      ctx.restore()
      ctx.filter = 'none'

      // 6. 绘制图片遮罩
      if (state.imageOverlay.enabled && state.imageOverlay.currentImage) {
        ctx.save()
        ctx.globalAlpha = state.imageOverlay.opacity / 100

        // 确保我们有一个 Image 对象用于绘制
        if (!state.imageOverlayElement) {
          state.imageOverlayElement = new Image()
        }

        // 只在 src 变化时更新，避免重复加载
        if (state.imageOverlayElement.src !== state.imageOverlay.currentImage) {
          state.imageOverlayElement.src = state.imageOverlay.currentImage
        }

        // 只有当图片加载完成后才绘制
        if (state.imageOverlayElement.complete) {
          try {
            ctx.drawImage(state.imageOverlayElement, 0, 0, w, h)
          } catch (e) {
            console.error('绘制图片遮罩失败:', e)
          }
        } else {
          // 如果图片还没加载完成，设置 onload 回调
          state.imageOverlayElement.onload = () => {
            // 图片加载完成后，下一帧会自动绘制
          }
        }

        ctx.restore()
      }

      // 5.5. 绘制真实摄像头
      if (state.realCamera.enabled && state.realCameraVideo) {
        const camera = state.realCamera
        const video = state.realCameraVideo

        console.log('绘制真实摄像头，透明度值：', camera.opacity); // 调试日志

        // 安全检查，确保坐标有效
        const x = (camera.position && typeof camera.position.x === 'number' && !isNaN(camera.position.x)) ? camera.position.x : 100
        const y = (camera.position && typeof camera.position.y === 'number' && !isNaN(camera.position.y)) ? camera.position.y : 100
        const targetWidth = (camera.size && typeof camera.size.width === 'number' && !isNaN(camera.size.width) && camera.size.width > 0) ? camera.size.width : 320
        const targetHeight = (camera.size && typeof camera.size.height === 'number' && !isNaN(camera.size.height) && camera.size.height > 0) ? camera.size.height : 240

        // 检查video元素是否有内容
        if (video.readyState >= 2) { // HAVE_CURRENT_DATA 或更高
          try {
            ctx.save()
            // 应用透明度
            ctx.globalAlpha = camera.opacity / 100
            console.log('应用透明度：', camera.opacity / 100); // 调试日志
            // 获取视频原始尺寸
            const videoWidth = video.videoWidth
            const videoHeight = video.videoHeight

            if (videoWidth > 0 && videoHeight > 0) {
              // 实现 object-fit: cover 效果
              const targetRatio = targetWidth / targetHeight
              const videoRatio = videoWidth / videoHeight

              let sourceX, sourceY, sourceWidth, sourceHeight

              if (videoRatio > targetRatio) {
                // 视频更宽 - 裁剪左右
                sourceHeight = videoHeight
                sourceWidth = videoHeight * targetRatio
                sourceX = (videoWidth - sourceWidth) / 2
                sourceY = 0
              } else {
                // 视频更高 - 裁剪上下
                sourceWidth = videoWidth
                sourceHeight = videoWidth / targetRatio
                sourceX = 0
                sourceY = (videoHeight - sourceHeight) / 2
              }

              // 使用9参数的 drawImage 实现裁剪和缩放
              ctx.drawImage(
                  video,
                  sourceX, sourceY, sourceWidth, sourceHeight, // 源裁剪
                  x, y, targetWidth, targetHeight               // 目标绘制
              )
            }
            ctx.restore()
          } catch (e) {
            console.error('绘制摄像头失败:', e)
          }
        } else {
          // 调试：如果视频还没准备好，画一个占位框
          ctx.strokeStyle = '#ff0000'
          ctx.lineWidth = 2
          ctx.strokeRect(
              x,
              y,
              targetWidth,
              targetHeight
          )
          // 添加调试文字
          ctx.fillStyle = '#ff0000'
          ctx.font = '14px Arial'
          ctx.fillText('摄像头准备中...', x + 10, y + 30)
        }
      } else if (state.realCamera.enabled) {
        // 调试：如果只有enabled没有video引用
        ctx.strokeStyle = '#ffaa00'
        ctx.lineWidth = 2
        ctx.strokeRect(100, 100, 320, 240)
        ctx.fillStyle = '#ffaa00'
        ctx.font = '14px Arial'
        ctx.fillText('缺少摄像头视频引用', 110, 130)
      }

      // 6. 渲染特效
      if (state.effects.enabled) {
        state.effectsTime++
        this.drawEffects(ctx, w, h)
      }

      // 7. 渲染热卖特效
      this.drawHotSaleEffects(ctx, w, h)

      // 8. 渲染智能贴片
      this.drawSmartOverlay(ctx, w, h)

      // 9. 渲染动态标题
      this.drawDynamicTitle(ctx, w, h)

      // 10. 通过 WebSocket 发送帧
      if (state.isVirtualCameraLive) {
        this.sendCanvasFrame()
      }
    },

    // 绘制特效
    drawEffects(ctx, w, h) {
      const state = this.globalCanvasState

      ctx.save()
      ctx.globalAlpha = state.effects.opacity / 100

      if (state.lastEffectType !== state.effects.type) {
        state.effectsParticles = []
        state.lastEffectType = state.effects.type
      }

      switch (state.effects.type) {
        case '字幕雨':
          this.drawTextRain(ctx, w, h)
          break
        case '雪花':
          this.drawSnow(ctx, w, h)
          break
        case '星空':
          this.drawStarfield(ctx, w, h)
          break
        case '动态杂点':
          this.drawNoise(ctx, w, h)
          break
        case '粒子线条':
          this.drawParticleLines(ctx, w, h)
          break
        case '彩色光斑':
          this.drawColorBokeh(ctx, w, h)
          break
        case '动态扫描线':
          this.drawScanlines(ctx, w, h)
          break
        case '混沌透视重塑':
          this.drawChaos(ctx, w, h)
          break

        case '色彩偏移':
          this.drawColorShift(ctx, w, h)
          break
        case '边缘流光':
          this.drawEdgeGlow(ctx, w, h)
          break
        case 'AI像素重组':
          this.drawPixelRecombine(ctx, w, h)
          break
      }

      ctx.restore()
    },

    // 字幕雨特效
    drawTextRain(ctx, w, h) {
      const state = this.globalCanvasState
      const chars = '01アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン'

      if (state.effectsParticles.length === 0) {
        for (let i = 0; i < 30; i++) {
          state.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            speed: 3 + Math.random() * 4,
            char: chars[Math.floor(Math.random() * chars.length)],
            opacity: 0.6 + Math.random() * 0.4
          })
        }
      }

      ctx.fillStyle = '#0f0'
      ctx.font = '32px monospace'

      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      state.effectsParticles.forEach(p => {
        // 乘以粒子自身的透明度
        ctx.globalAlpha = currentAlpha * p.opacity
        ctx.fillText(p.char, p.x, p.y)
        p.y += p.speed
        if (p.y > h) {
          p.y = 0
          p.x = Math.random() * w
        }
      })

      // 恢复 globalAlpha
      ctx.globalAlpha = currentAlpha
    },

    // 雪花特效
    drawSnow(ctx, w, h) {
      const state = this.globalCanvasState

      if (state.effectsParticles.length === 0) {
        for (let i = 0; i < 50; i++) {
          state.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            size: 1 + Math.random() * 3,
            speed: 1 + Math.random() * 2,
            sway: -0.5 + Math.random()
          })
        }
      }

      ctx.fillStyle = '#fff'

      state.effectsParticles.forEach(p => {
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2)
        ctx.fill()
        p.y += p.speed
        p.x += Math.sin(state.effectsTime * 0.01 + p.x) * p.sway
        if (p.y > h) {
          p.y = 0
          p.x = Math.random() * w
        }
      })
    },

    // 星空特效
    drawStarfield(ctx, w, h) {
      const state = this.globalCanvasState

      if (state.effectsParticles.length === 0) {
        for (let i = 0; i < 100; i++) {
          state.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            size: 0.5 + Math.random() * 1.5,
            twinkle: Math.random()
          })
        }
      }

      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      state.effectsParticles.forEach(p => {
        const alpha = 0.3 + Math.sin(state.effectsTime * 0.05 + p.twinkle * 10) * 0.3
        // 乘以全局特效透明度
        const finalAlpha = alpha * currentAlpha
        ctx.fillStyle = `rgba(255, 255, 255, ${finalAlpha})`
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2)
        ctx.fill()
      })
    },

    // 动态彩色气泡
    drawNoise(ctx, w, h) {
      const state = this.globalCanvasState
      const time = state.effectsTime
      const currentAlpha = ctx.globalAlpha

      // 初始化气泡粒子
      if (state.effectsParticles.length === 0) {
        for (let i = 0; i < 80; i++) {
          state.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            size: 2 + Math.random() * 8,
            speed: 0.3 + Math.random() * 1.2,
            hue: Math.random() * 360,
            wobble: Math.random() * Math.PI * 2,
            wobbleSpeed: 0.02 + Math.random() * 0.03
          })
        }
      }

      const baseAlpha = 0.4
      ctx.globalAlpha = baseAlpha * currentAlpha

      // 绘制气泡
      state.effectsParticles.forEach(bubble => {
        // 更新位置
        bubble.y -= bubble.speed
        bubble.wobble += bubble.wobbleSpeed
        bubble.x += Math.sin(bubble.wobble) * 0.5

        // 循环边界
        if (bubble.y < -bubble.size * 2) {
          bubble.y = h + bubble.size
          bubble.x = Math.random() * w
        }

        // 绘制带渐变气泡
        const gradient = ctx.createRadialGradient(
            bubble.x - bubble.size * 0.3,
            bubble.y - bubble.size * 0.3,
            0,
            bubble.x,
            bubble.y,
            bubble.size
        )
        gradient.addColorStop(0, `hsla(${bubble.hue}, 85%, 70%, 0.8)`)
        gradient.addColorStop(0.7, `hsla(${bubble.hue}, 85%, 60%, 0.3)`)
        gradient.addColorStop(1, `hsla(${bubble.hue}, 85%, 50%, 0)`)

        ctx.beginPath()
        ctx.arc(bubble.x, bubble.y, bubble.size, 0, Math.PI * 2)
        ctx.fillStyle = gradient
        ctx.fill()
      })

      ctx.globalAlpha = currentAlpha
    },

    // 粒子线条
    drawParticleLines(ctx, w, h) {
      const state = this.globalCanvasState

      if (state.effectsParticles.length === 0) {
        for (let i = 0; i < 60; i++) {
          state.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            vx: -2 + Math.random() * 4,
            vy: -2 + Math.random() * 4
          })
        }
      }

      // 第一层线条（青色，较粗）
      ctx.strokeStyle = 'rgb(0, 200, 255)'
      ctx.lineWidth = 2.5

      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      state.effectsParticles.forEach((p, i) => {
        p.x += p.vx
        p.y += p.vy
        if (p.x < 0 || p.x > w) p.vx *= -1
        if (p.y < 0 || p.y > h) p.vy *= -1

        state.effectsParticles.slice(i + 1).forEach(other => {
          const dist = Math.hypot(p.x - other.x, p.y - other.y)
          if (dist < 150) {
            ctx.globalAlpha = (1 - dist / 150) * 0.8 * currentAlpha
            ctx.beginPath()
            ctx.moveTo(p.x, p.y)
            ctx.lineTo(other.x, other.y)
            ctx.stroke()
          }
        })
      })

      // 第二层线条（品红色，较细，偏移）
      ctx.strokeStyle = 'rgb(255, 50, 150)'
      ctx.lineWidth = 1.5

      state.effectsParticles.forEach((p, i) => {
        state.effectsParticles.slice(i + 1).forEach(other => {
          const dist = Math.hypot(p.x - other.x, p.y - other.y)
          if (dist < 120) {
            ctx.globalAlpha = (1 - dist / 120) * 0.5 * currentAlpha
            ctx.beginPath()
            ctx.moveTo(p.x + 3, p.y + 2)
            ctx.lineTo(other.x + 3, other.y + 2)
            ctx.stroke()
          }
        })
      })

      // 绘制粒子点
      ctx.globalAlpha = 0.9 * currentAlpha
      state.effectsParticles.forEach(p => {
        ctx.fillStyle = 'rgb(0, 200, 255)'
        ctx.beginPath()
        ctx.arc(p.x, p.y, 4, 0, Math.PI * 2)
        ctx.fill()

        ctx.fillStyle = 'rgb(255, 50, 150)'
        ctx.beginPath()
        ctx.arc(p.x + 2, p.y + 1, 2.5, 0, Math.PI * 2)
        ctx.fill()
      })

      // 恢复 globalAlpha
      ctx.globalAlpha = currentAlpha
    },

    // 彩色光斑
    drawColorBokeh(ctx, w, h) {
      const state = this.globalCanvasState
      const colors = ['rgba(255, 100, 100, 0.3)', 'rgba(100, 255, 100, 0.3)', 'rgba(100, 100, 255, 0.3)', 'rgba(255, 255, 100, 0.3)']

      if (state.effectsParticles.length === 0) {
        for (let i = 0; i < 20; i++) {
          state.effectsParticles.push({
            x: Math.random() * w,
            y: Math.random() * h,
            size: 20 + Math.random() * 40,
            color: colors[Math.floor(Math.random() * colors.length)],
            speed: 0.2 + Math.random() * 0.5
          })
        }
      }

      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      state.effectsParticles.forEach(p => {
        // 解析颜色并乘以全局透明度
        let adjustedColor = p.color
        const rgbaMatch = p.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]+)?\)/)
        if (rgbaMatch) {
          const r = rgbaMatch[1]
          const g = rgbaMatch[2]
          const b = rgbaMatch[3]
          const a = parseFloat(rgbaMatch[4] || '1') * currentAlpha
          adjustedColor = `rgba(${r}, ${g}, ${b}, ${a})`
        }

        const gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size)
        gradient.addColorStop(0, adjustedColor)
        gradient.addColorStop(1, 'rgba(0, 0, 0, 0)')
        ctx.fillStyle = gradient
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2)
        ctx.fill()
        p.y -= p.speed
        if (p.y < -p.size) {
          p.y = h + p.size
          p.x = Math.random() * w
        }
      })
    },

    // 动态扫描线
    drawScanlines(ctx, w, h) {
      const state = this.globalCanvasState
      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha
      // 乘以全局特效透明度
      ctx.fillStyle = `rgba(0, 0, 0, ${0.1 * currentAlpha})`

      for (let y = 0; y < h; y += 4) {
        const offset = (state.effectsTime + y) % h
        ctx.fillRect(0, y, w, 2)
      }
    },

    // 混沌透视重塑
    drawChaos(ctx, w, h) {
      const state = this.globalCanvasState
      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha
      ctx.save()

      const time = Date.now() / 1000
      const distortion = Math.sin(time * 2) * 25

      ctx.translate(w / 2, h / 2)
      ctx.rotate(Math.sin(time * 1.5) * 0.15)
      ctx.scale(1 + Math.sin(time * 2.2) * 0.12, 1 + Math.cos(time * 1.8) * 0.12)
      ctx.translate(-w / 2, -h / 2)

      // 绘制第一层网格（青色）
      ctx.strokeStyle = `rgba(0, 200, 255, ${0.6 * currentAlpha})`
      ctx.lineWidth = 2
      for (let i = 0; i < w; i += 35) {
        ctx.beginPath()
        ctx.moveTo(i + Math.sin(time * 2 + i * 0.05) * distortion, 0)
        ctx.lineTo(i + Math.sin(time * 2 + i * 0.05 + 1) * distortion, h)
        ctx.stroke()
      }
      for (let i = 0; i < h; i += 35) {
        ctx.beginPath()
        ctx.moveTo(0, i + Math.cos(time * 2 + i * 0.05) * distortion)
        ctx.lineTo(w, i + Math.cos(time * 2 + i * 0.05 + 1) * distortion)
        ctx.stroke()
      }

      // 绘制第二层网格（品红色，偏移）
      ctx.strokeStyle = `rgba(255, 0, 150, ${0.4 * currentAlpha})`
      ctx.lineWidth = 1.5
      const offset = 17
      for (let i = offset; i < w; i += 35) {
        ctx.beginPath()
        ctx.moveTo(i + Math.sin(time * 2.5 + i * 0.05) * distortion * 0.7, 0)
        ctx.lineTo(i + Math.sin(time * 2.5 + i * 0.05 + 1) * distortion * 0.7, h)
        ctx.stroke()
      }
      for (let i = offset; i < h; i += 35) {
        ctx.beginPath()
        ctx.moveTo(0, i + Math.cos(time * 2.5 + i * 0.05) * distortion * 0.7)
        ctx.lineTo(w, i + Math.cos(time * 2.5 + i * 0.05 + 1) * distortion * 0.7)
        ctx.stroke()
      }

      ctx.restore()
    },

/*    // 动态网格变形
    drawMoire(ctx, w, h) {
      const state = this.globalCanvasState
      const time = state.effectsTime * 0.015
      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      // 设置颜色和线宽
      ctx.strokeStyle = 'rgb(0, 200, 255)'
      ctx.lineWidth = 2
      ctx.globalAlpha = 0.6 * currentAlpha

      // 网格间距
      const gridSize = 40

      // 绘制垂直线
      for (let x = 0; x <= w; x += gridSize) {
        ctx.beginPath()
        for (let y = 0; y <= h; y += 10) {
          const wave = Math.sin(time + x * 0.02 + y * 0.01) * 8
          const xPos = x + wave

          if (y === 0) {
            ctx.moveTo(xPos, y)
          } else {
            ctx.lineTo(xPos, y)
          }
        }
        ctx.stroke()
      }

      // 绘制水平线
      for (let y = 0; y <= h; y += gridSize) {
        ctx.beginPath()
        for (let x = 0; x <= w; x += 10) {
          const wave = Math.cos(time + x * 0.01 + y * 0.02) * 8
          const yPos = y + wave

          if (x === 0) {
            ctx.moveTo(x, yPos)
          } else {
            ctx.lineTo(x, yPos)
          }
        }
        ctx.stroke()
      }

      // 绘制彩色交点
      ctx.globalAlpha = 0.8 * currentAlpha
      for (let x = 0; x <= w; x += gridSize) {
        for (let y = 0; y <= h; y += gridSize) {
          const waveX = Math.sin(time + x * 0.02 + y * 0.01) * 8
          const waveY = Math.cos(time + x * 0.01 + y * 0.02) * 8

          const hue = (time * 20 + x * 0.5 + y * 0.3) % 360
          ctx.fillStyle = `hsl(${hue}, 100%, 60%)`
          ctx.beginPath()
          ctx.arc(x + waveX, y + waveY, 3, 0, Math.PI * 2)
          ctx.fill()
        }
      }

      // 恢复 globalAlpha
      ctx.globalAlpha = currentAlpha
    },*/

    // 色彩偏移
    drawColorShift(ctx, w, h) {
      const state = this.globalCanvasState
      const time = state.effectsTime * 0.01
      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      ctx.globalCompositeOperation = 'lighter'

      // 乘以全局特效透明度
      ctx.fillStyle = `rgba(255, 0, 0, ${0.05 * currentAlpha})`
      ctx.fillRect(Math.sin(time) * 5, 0, w, h)

      ctx.fillStyle = `rgba(0, 255, 0, ${0.05 * currentAlpha})`
      ctx.fillRect(Math.cos(time) * 5, 0, w, h)

      ctx.fillStyle = `rgba(0, 0, 255, ${0.05 * currentAlpha})`
      ctx.fillRect(Math.sin(time + Math.PI) * 5, 0, w, h)

      ctx.globalCompositeOperation = 'source-over'
    },

    // 边缘流光
    drawEdgeGlow(ctx, w, h) {
      const state = this.globalCanvasState
      const time = Date.now() / 1000
      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      // 1. 核心：高随机性参数，确保每一秒的像素特征都不重复 (去重核心)
      // 使用 sine 波嵌套产生非线性速度
      const speedBase = time * 0.8
      const drift = Math.sin(time * 0.5) * 2.0
      const pos = (speedBase + drift) % 1.0

      const perimeter = 2 * (w + h)
      const currentDist = pos * perimeter

      // 2. 随机长度和粗细
      const lightLen = perimeter * (0.15 + Math.abs(Math.sin(time)) * 0.2)
      // 核心修复：前端 Canvas 的 lineWidth 是基于物理像素的
      // 为了与后端 1080p 效果一致，这里需要根据当前 canvas 高度进行缩放
      const lineWidth = (4 + Math.abs(Math.cos(time * 0.7)) * 8) * (h / 720)

      ctx.lineCap = 'round'

      const getPoint = (dist) => {
        dist = (dist + perimeter) % perimeter
        if (dist < w) return {x: dist, y: 0}
        if (dist < w + h) return {x: w, y: dist - w}
        if (dist < 2 * w + h) return {x: w - (dist - (w + h)), y: h}
        return {x: 0, y: h - (dist - (2 * w + h))}
      }

      // 3. 多重重叠流光，增加画面复杂度，干扰平台 MD5 和像素对比
      const layers = [
        {offset: 0, color: '0, 212, 255', opMult: 1.0},
        {offset: perimeter * 0.5, color: '255, 107, 107', opMult: 0.6}, // 对向流光
      ]

      layers.forEach(layer => {
        const startDist = (currentDist + layer.offset) % perimeter
        const segments = 15
        for (let i = 0; i < segments; i++) {
          const p1Dist = startDist + (i / segments) * lightLen
          const p2Dist = startDist + ((i + 1) / segments) * lightLen
          const p1 = getPoint(p1Dist)
          const p2 = getPoint(p2Dist)

          // 随机透明度抖动
          const flicker = 0.8 + Math.random() * 0.2
          const alpha = (i / segments) * 0.8 * layer.opMult * flicker * currentAlpha

          ctx.strokeStyle = `rgba(${layer.color}, ${alpha})`
          ctx.lineWidth = lineWidth * (i / segments) // 头部粗尾部细
          ctx.beginPath()
          ctx.moveTo(p1.x, p1.y)
          ctx.lineTo(p2.x, p2.y)
          ctx.stroke()
        }
      })
    },

    // AI像素重组
    drawPixelRecombine(ctx, w, h) {
      const state = this.globalCanvasState
      const blockSize = 20
      const time = state.effectsTime * 0.1
      // 保存当前的 globalAlpha
      const currentAlpha = ctx.globalAlpha

      for (let y = 0; y < h; y += blockSize) {
        for (let x = 0; x < w; x += blockSize) {
          const offsetX = Math.sin(time + x * 0.1 + y * 0.1) * 5
          const offsetY = Math.cos(time + x * 0.1 + y * 0.1) * 5

          if (Math.random() > 0.95) {
            // 乘以全局特效透明度
            ctx.fillStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, ${0.1 * currentAlpha})`
            ctx.fillRect(x + offsetX, y + offsetY, blockSize, blockSize)
          }
        }
      }
    },

    // 加载热卖特效图片
    loadHotSaleImages() {
      const state = this.globalCanvasState

      // 创建隐藏的 DOM img 元素来播放动画
      const hotSaleImg = document.createElement('img')
      hotSaleImg.src = require("@/access/tx/hotSale.webp")

      hotSaleImg.crossOrigin = 'anonymous'
      hotSaleImg.style.display = 'none'
      document.body.appendChild(hotSaleImg)
      state.hotSaleState.hotSaleImage = hotSaleImg

      // 加载库存图片
      const inventoryImg = document.createElement('img')
      inventoryImg.src = require("@/access/tx/stock.webp")
      inventoryImg.crossOrigin = 'anonymous'
      inventoryImg.style.display = 'none'
      document.body.appendChild(inventoryImg)
      state.hotSaleState.inventoryImage = inventoryImg
    },

    // 绘制热卖特效
    drawHotSaleEffects(ctx, w, h) {
      const hotSaleParams = this.$store.state.hotSaleParams
      if (!hotSaleParams) return

      const state = this.globalCanvasState

      // 先检查特效状态跟踪（用于入场动画）
      const hotSaleWasEnabled = state.hotSaleState._hotSaleEnabled
      if (hotSaleParams.hotImageEffect.enabled) {
        if (!hotSaleWasEnabled) {
          state.hotSaleState.hotSaleStartTime = Date.now()
          state.hotSaleState.lastHotSaleCount = hotSaleParams.hotImageEffect.count // 开启时同步，避免触发弹出动画
        }
        state.hotSaleState._hotSaleEnabled = true
      } else {
        state.hotSaleState._hotSaleEnabled = false
      }

      const inventoryWasEnabled = state.hotSaleState._inventoryEnabled
      if (hotSaleParams.inventoryEffect.enabled) {
        if (!inventoryWasEnabled) {
          state.hotSaleState.inventoryStartTime = Date.now()
          state.hotSaleState.lastInventoryCount = hotSaleParams.inventoryEffect.count // 开启时同步，避免触发弹出动画
        }
        state.hotSaleState._inventoryEnabled = true
      } else {
        state.hotSaleState._inventoryEnabled = false
      }

      // 检测热卖 count 变化，启动弹出动画（仅当特效已经是开启状态）
      if (hotSaleParams.hotImageEffect.enabled && hotSaleWasEnabled) {
        if (state.hotSaleState.lastHotSaleCount !== hotSaleParams.hotImageEffect.count) {
          state.hotSaleState.hotSalePopping = true
          state.hotSaleState.hotSalePoppingStartTime = Date.now()
          state.hotSaleState.lastHotSaleCount = hotSaleParams.hotImageEffect.count
        }
      }

      // 检测库存 count 变化，启动弹出动画（仅当特效已经是开启状态）
      if (hotSaleParams.inventoryEffect.enabled && inventoryWasEnabled) {
        if (state.hotSaleState.lastInventoryCount !== hotSaleParams.inventoryEffect.count) {
          state.hotSaleState.inventoryPopping = true
          state.hotSaleState.inventoryPoppingStartTime = Date.now()
          state.hotSaleState.lastInventoryCount = hotSaleParams.inventoryEffect.count
        }
      }

      if (hotSaleParams.purchaseEffect.enabled && hotSaleParams.purchaseEffect.visible) {
        if (!state.hotSaleState._purchaseEnabled) {
          state.hotSaleState.purchaseStartTime = Date.now()
        }
        state.hotSaleState._purchaseEnabled = true
      } else {
        state.hotSaleState._purchaseEnabled = false
      }

      // 预览区域尺寸(手机屏幕)
      const previewWidth = 360
      const previewHeight = 640

      // 计算缩放比例
      const scaleX = w / previewWidth
      const scaleY = h / previewHeight
      const scale = Math.min(scaleX, scaleY)

      // 计算居中偏移
      const offsetX = (w - previewWidth * scale) / 2
      const offsetY = (h - previewHeight * scale) / 2

      ctx.save()
      ctx.translate(offsetX, offsetY)
      ctx.scale(scale, scale)

      // 绘制热卖飘屏
      if (hotSaleParams.hotImageEffect.enabled) {
        this.drawHotSaleEffect(ctx, 360, 640, hotSaleParams.hotImageEffect, 1, 0, 0, 640)
      }

      // 绘制库存飘屏
      if (hotSaleParams.inventoryEffect.enabled) {
        this.drawInventoryEffect(ctx, 360, 640, hotSaleParams.inventoryEffect, 1, 0, 0, 640)
      }

      // 绘制购买飘屏
      if (hotSaleParams.purchaseEffect.enabled && hotSaleParams.purchaseEffect.visible) {
        this.drawPurchaseEffect(ctx, 360, 640, hotSaleParams.purchaseEffect, 1, 0, 0, 640)
      }

      // 绘制上下文字滚动
      if (hotSaleParams.textScrollEffect.enabled) {
        this.drawTextScrollEffect(ctx, 360, 640, hotSaleParams.textScrollEffect, 1, 0, 0, 640)
      }

      // 绘制左右文字滚动
      if (hotSaleParams.marqueeEffect.enabled) {
        this.drawMarqueeEffect(ctx, 360, 640, hotSaleParams.marqueeEffect, 1, 0, 0, 640)
      }

      // 绘制动态闪烁文字
      if (hotSaleParams.flashTextEffect.enabled) {
        this.drawFlashTextEffect(ctx, 360, 640, hotSaleParams.flashTextEffect, 1, 0, 0, 640)
      }

      ctx.restore()
    },

    // 绘制热卖飘屏
    drawHotSaleEffect(ctx, w, h, effect, scale, offsetX, offsetY, previewHeight) {
      const state = this.globalCanvasState
      const img = state.hotSaleState.hotSaleImage

      // 直接在 360x640 坐标系绘制
      const previewX = effect.left
      const previewBottom = effect.bottom
      const previewY = 640 - previewBottom

      const x = previewX
      const y = previewY

      // 固定容器高度，在预览中是 32px
      const baseContainerHeight = 32
      const containerHeight = baseContainerHeight
      const imgHeight = containerHeight
      const borderRadius = containerHeight / 2

      // 字体大小在预览中默认是 26px，根据 effect.fontSize 计算比例
      const fontSizeScale = effect.fontSize / 26
      const fontSize = 26 * fontSizeScale
      const xFontSize = 14 * fontSizeScale

      // 动画效果计算
      const now = Date.now()
      const elapsed = (now - state.hotSaleState.hotSaleStartTime) / 1000

      // 入场动画 0.5秒 - 和参考文件完全一致：cubic-bezier(0.175,0.885,0.32,1.275)
      let scaleAnim = 1
      let translateX = 0
      let opacity = 1
      if (elapsed < 0.5) {
        const t = elapsed / 0.5
        // 实现 cubic-bezier(0.175, 0.885, 0.32, 1.275)
        const customEase = (t) => {
          const c1 = 0.885
          const c3 = c1 + 1
          return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
        }
        // 从 scale 0.8 → 1，从 translateX -50px → 0（和 @keyframes hot-sale-entry 一致）
        scaleAnim = 0.8 + 0.2 * customEase(t)
        translateX = -50 * (1 - t)
        opacity = t
      }

      // 弹出动画效果 - 和参考文件完全一致
      let popScale = 1
      if (state.hotSaleState.hotSalePopping) {
        const popElapsed = (now - state.hotSaleState.hotSalePoppingStartTime) / 1000
        if (popElapsed < 0.3) {
          // 参考文件是: transition 0.2s cubic-bezier(0.34,1.56,0.64,1)
          // 先在 0.15s 内弹到 1.2，然后在 0.15s 内弹回 1
          const t = popElapsed / 0.3
          const easeOutBack = (t) => {
            const c1 = 1.56
            const c3 = c1 + 1
            return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
          }
          if (t < 0.5) {
            // 0-0.15s: 从 1 到 1.2
            const t1 = t * 2
            popScale = 1 + 0.2 * easeOutBack(t1)
          } else {
            // 0.15-0.3s: 从 1.2 回到 1
            const t2 = (t - 0.5) * 2
            popScale = 1.2 - 0.2 * (easeOutBack(t2) - 1)
          }
        } else {
          state.hotSaleState.hotSalePopping = false
        }
      }

      // 先计算图片宽度
      let actualImgWidth = 0
      if (img && img.complete) {
        const imgRatio = img.width / img.height
        actualImgWidth = imgHeight * imgRatio
      }

      // 先绘制文字，计算内容总宽度
      ctx.font = `italic 700 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      let countText = effect.count > 9999 ? '9999' : effect.count.toString()
      if (effect.count >= 9999) {
        countText += '+'
      }
      const numWidth = ctx.measureText(countText).width

      ctx.font = `italic 700 ${xFontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      const xWidth = ctx.measureText('x').width

      // 计算渐变宽度 = 图片宽度 + 4px + x宽度 + 5px + 数字宽度 + 10px padding
      let contentWidth = (actualImgWidth + 4 + 5 + 10 + xWidth + numWidth)
      let gradientWidth = Math.max(contentWidth, containerHeight * 4)

      ctx.save()

      // 应用变换
      ctx.globalAlpha = opacity
      // 以容器中心为原点应用缩放
      const centerX = x + gradientWidth / 2
      const centerY = y - containerHeight / 2

      ctx.translate(centerX + translateX, centerY)
      ctx.scale(scaleAnim * popScale, scaleAnim * popScale)
      ctx.translate(-centerX, -centerY)

      // 绘制渐变背景 - 从右向左渐变（270度）
      const gradient = ctx.createLinearGradient(x + gradientWidth, y - containerHeight, x, y - containerHeight)
      gradient.addColorStop(0.0396, 'rgba(255, 177, 26, 0)') // 右边透明
      gradient.addColorStop(0.203, 'rgba(255, 177, 26, 0.6)')
      gradient.addColorStop(0.8614, 'rgba(255, 177, 26, 0.8)') // 左边不透明

      ctx.fillStyle = gradient
      ctx.beginPath()

      // 正确绘制只有左侧圆角的矩形
      // 从左上角开始，顺时针绘制
      ctx.moveTo(x + borderRadius, y - containerHeight)
      ctx.arc(x + borderRadius, y - containerHeight + borderRadius, borderRadius, Math.PI * 1.5, Math.PI, true)
      ctx.lineTo(x, y - borderRadius)
      ctx.arc(x + borderRadius, y - borderRadius, borderRadius, Math.PI, Math.PI * 0.5, true)
      ctx.lineTo(x + gradientWidth, y)
      ctx.lineTo(x + gradientWidth, y - containerHeight)
      ctx.closePath()
      ctx.fill()

      // 绘制热卖图标
      if (img && img.complete) {
        ctx.drawImage(img, x, y - imgHeight, actualImgWidth, imgHeight)
      }

      // 绘制乘号（白色、斜体）
      ctx.font = `italic 700 ${xFontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.fillStyle = '#ffffff'
      ctx.textBaseline = 'middle'
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 4
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 2

      const xText = x + actualImgWidth + 4 // margin-left:4px
      const yText = y - containerHeight / 2 + 3 // 整体居中 + top:3px往下
      ctx.fillText('x', xText, yText)

      // 绘制数字（白色、斜体、带阴影）
      ctx.font = `italic 700 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.fillStyle = '#ffffff'
      ctx.textBaseline = 'middle'

      // 计算x的宽度，再加5px margin-left
      const numText = xText + xWidth + 5
      const numYText = y - containerHeight / 2 // 数字垂直居中
      ctx.fillText(countText, numText, numYText)

      ctx.restore()
    },

    // 绘制库存飘屏
    drawInventoryEffect(ctx, w, h, effect, scale, offsetX, offsetY, previewHeight) {
      const state = this.globalCanvasState
      const img = state.hotSaleState.inventoryImage

      // 直接在 360x640 坐标系绘制
      const previewX = effect.left
      const previewBottom = effect.bottom
      const previewY = 640 - previewBottom

      const x = previewX
      const y = previewY

      // 固定容器高度，在预览中是 32px
      const baseContainerHeight = 32
      const containerHeight = baseContainerHeight
      const imgHeight = containerHeight
      const borderRadius = containerHeight / 2

      // 字体大小在预览中默认是 24px，根据 effect.fontSize 计算比例
      const fontSizeScale = effect.fontSize / 24
      const fontSize = 24 * fontSizeScale
      const xFontSize = 14 * fontSizeScale

      // 动画效果计算
      const now = Date.now()
      const elapsed = (now - state.hotSaleState.inventoryStartTime) / 1000

      // 入场动画 0.5秒 - 和参考文件完全一致：cubic-bezier(0.175,0.885,0.32,1.275)
      let scaleAnim = 1
      let translateX = 0
      let opacity = 1
      if (elapsed < 0.5) {
        const t = elapsed / 0.5
        // 实现 cubic-bezier(0.175, 0.885, 0.32, 1.275)
        const customEase = (t) => {
          const c1 = 0.885
          const c3 = c1 + 1
          return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
        }
        // 从 scale 0.8 → 1，从 translateX -50px → 0（和 @keyframes hot-sale-entry 一致）
        scaleAnim = 0.8 + 0.2 * customEase(t)
        translateX = -50 * (1 - t)
        opacity = t
      }

      // 弹出动画效果 - 和参考文件完全一致（库存是 scale(1.15)）
      let popScale = 1
      if (state.hotSaleState.inventoryPopping) {
        const popElapsed = (now - state.hotSaleState.inventoryPoppingStartTime) / 1000
        if (popElapsed < 0.3) {
          // 参考文件是: transition 0.2s cubic-bezier(0.34,1.56,0.64,1)
          // 先在 0.15s 内弹到 1.15，然后在 0.15s 内弹回 1
          const t = popElapsed / 0.3
          const easeOutBack = (t) => {
            const c1 = 1.56
            const c3 = c1 + 1
            return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
          }
          if (t < 0.5) {
            // 0-0.15s: 从 1 到 1.15
            const t1 = t * 2
            popScale = 1 + 0.15 * easeOutBack(t1)
          } else {
            // 0.15-0.3s: 从 1.15 回到 1
            const t2 = (t - 0.5) * 2
            popScale = 1.15 - 0.15 * (easeOutBack(t2) - 1)
          }
        } else {
          state.hotSaleState.inventoryPopping = false
        }
      }

      // 先计算图片宽度
      let actualImgWidth = 0
      if (img && img.complete) {
        const imgRatio = img.width / img.height
        actualImgWidth = imgHeight * imgRatio
      }

      // 先绘制文字，计算内容总宽度
      ctx.font = `italic 700 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      const countText = effect.count.toString()
      const numWidth = ctx.measureText(countText).width

      ctx.font = `italic 700 ${xFontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      const xWidth = ctx.measureText('x').width

      // 计算渐变宽度 = 图片宽度 + 4px + x宽度 + 5px + 数字宽度 + 12px padding
      let contentWidth = (actualImgWidth + 4 + 5 + 12 + xWidth + numWidth)
      let gradientWidth = Math.max(contentWidth, containerHeight * 4)

      ctx.save()

      // 应用变换
      ctx.globalAlpha = opacity
      // 以容器中心为原点应用缩放
      const centerX = x + gradientWidth / 2
      const centerY = y - containerHeight / 2

      ctx.translate(centerX + translateX, centerY)
      ctx.scale(scaleAnim * popScale, scaleAnim * popScale)
      ctx.translate(-centerX, -centerY)

      // 绘制渐变背景（粉色渐变，从左到右）
      const gradient = ctx.createLinearGradient(x, y - containerHeight, x + gradientWidth, y - containerHeight)
      gradient.addColorStop(0.1009, 'rgba(255, 69, 181, 0.8)')
      gradient.addColorStop(0.7916, 'rgba(255, 69, 181, 0.7)')
      gradient.addColorStop(0.9776, 'rgba(255, 69, 181, 0)') // 右边透明

      ctx.fillStyle = gradient
      ctx.beginPath()

      // 正确绘制只有左侧圆角的矩形
      // 从左上角开始，顺时针绘制
      ctx.moveTo(x + borderRadius, y - containerHeight)
      ctx.arc(x + borderRadius, y - containerHeight + borderRadius, borderRadius, Math.PI * 1.5, Math.PI, true)
      ctx.lineTo(x, y - borderRadius)
      ctx.arc(x + borderRadius, y - borderRadius, borderRadius, Math.PI, Math.PI * 0.5, true)
      ctx.lineTo(x + gradientWidth, y)
      ctx.lineTo(x + gradientWidth, y - containerHeight)
      ctx.closePath()
      ctx.fill()

      // 绘制库存图标
      if (img && img.complete) {
        ctx.drawImage(img, x, y - imgHeight, actualImgWidth, imgHeight)
      }

      // 绘制乘号（白色、斜体）
      ctx.font = `italic 700 ${xFontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.fillStyle = '#ffffff'
      ctx.textBaseline = 'middle'
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 4
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 2

      const xText = x + actualImgWidth + 4 // margin-left:4px
      const yText = y - containerHeight / 2 + 3 // 整体居中 + top:3px往下
      ctx.fillText('x', xText, yText)

      // 绘制数字（白色、斜体、带阴影）
      ctx.font = `italic 700 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.fillStyle = '#ffffff'
      ctx.textBaseline = 'middle'

      // 计算x的宽度，再加5px margin-left
      const numText = xText + xWidth + 5
      const numYText = y - containerHeight / 2 // 数字垂直居中
      ctx.fillText(countText, numText, numYText)

      ctx.restore()
    },

    // 绘制购买飘屏
    drawPurchaseEffect(ctx, w, h, effect, scale, offsetX, offsetY, previewHeight) {
      const state = this.globalCanvasState

      // 直接在 360x640 坐标系绘制
      const previewX = effect.left
      const previewBottom = effect.bottom
      // purchase-banner 高度是 64px，文字垂直居中，所以文字中线是预览中的 (640 - previewBottom - 32)
      const previewY = 640 - previewBottom - 32

      const x = previewX
      const y = previewY

      // 预览中默认字体大小是 26px，根据 effect.fontSize 计算比例
      const fontSizeScale = effect.fontSize / 26
      const fontSize = 26 * fontSizeScale

      // 预览中 banner 的 padding-left 是 20px，文字垂直居中
      const paddingLeft = 20

      // 动画效果计算
      const now = Date.now()
      const elapsed = (now - state.hotSaleState.purchaseStartTime) / 1000

      // 入场动画：0.5s 从左往右弹出，然后停顿 - 和参考文件完全一致
      let translateX = 0
      let opacity = 1
      if (elapsed < 0.5) {
        const t = elapsed / 0.5
        const customEase = (t) => {
          const c1 = 0.885
          const c3 = c1 + 1
          return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2)
        }
        // 从 translateX(-100%) → 0
        translateX = -360 * (1 - customEase(t))
        opacity = t
      }

      ctx.save()

      // 应用变换
      ctx.globalAlpha = opacity
      ctx.translate(translateX, 0)

      // 绘制文字（白色、加粗、带阴影，左对齐）
      const text = `@${effect.currentUser}***等${effect.currentCount}人，正在去购买`
      ctx.font = `700 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.fillStyle = '#ffffff'
      ctx.textAlign = 'left'
      ctx.textBaseline = 'middle' // 和 DOM 中的 align-items: center 一致
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 4
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 2
      ctx.fillText(text, x + paddingLeft, y)

      ctx.restore()
    },

    // 绘制上下文字滚动
    drawTextScrollEffect(ctx, w, h, effect, scale, offsetX, offsetY, previewHeight) {
      const state = this.globalCanvasState

      ctx.save()
      ctx.globalAlpha = effect.opacity / 100

      // 直接在 360x640 坐标系绘制
      const x = effect.left
      const y = 640 - effect.bottom
      const fontSize = effect.fontSize
      const containerWidth = effect.width
      const containerHeight = effect.height
      const borderRadius = fontSize * 0.5
      const padding = fontSize * 0.5

      // 绘制圆角背景 (DOM 中 padding 是包含在容器内部的)
      ctx.beginPath()
      ctx.moveTo(x + borderRadius, y - containerHeight)
      ctx.lineTo(x + containerWidth - borderRadius, y - containerHeight)
      ctx.quadraticCurveTo(x + containerWidth, y - containerHeight, x + containerWidth, y - containerHeight + borderRadius)
      ctx.lineTo(x + containerWidth, y - borderRadius)
      ctx.quadraticCurveTo(x + containerWidth, y, x + containerWidth - borderRadius, y)
      ctx.lineTo(x + borderRadius, y)
      ctx.quadraticCurveTo(x, y, x, y - borderRadius)
      ctx.lineTo(x, y - containerHeight + borderRadius)
      ctx.quadraticCurveTo(x, y - containerHeight, x + borderRadius, y - containerHeight)
      ctx.closePath()
      ctx.fillStyle = effect.backgroundColor
      ctx.fill()

      // 绘制边框
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)'
      ctx.lineWidth = 1
      ctx.stroke()

      // 裁剪区域
      ctx.beginPath()
      ctx.rect(x, y - containerHeight, containerWidth, containerHeight)
      ctx.clip()

      // 更新滚动偏移 (根据 DOM 动画： animationDuration: 10 / speed，总距离是 items.length * lineHeight)
      const lineHeight = fontSize * 1.5
      const totalScrollDistance = effect.items.length * lineHeight
      const animationDuration = 10 / effect.speed // 秒
      const pixelsPerFrame = totalScrollDistance / (animationDuration * 60) // 假设 60fps
      state.hotSaleState.textScrollOffset += pixelsPerFrame

      // 设置字体样式
      ctx.font = `${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.fillStyle = effect.color
      ctx.textAlign = 'left'
      ctx.textBaseline = 'top'

      // 添加文字阴影
      ctx.shadowColor = 'rgba(0, 0, 0, 0.8)'
      ctx.shadowBlur = 2
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 1

      // 重复两次文字以实现无缝滚动，考虑 padding
      for (let loop = 0; loop < 2; loop++) {
        for (let i = 0; i < effect.items.length; i++) {
          const textY = y - containerHeight + padding + i * lineHeight - (state.hotSaleState.textScrollOffset % (effect.items.length * lineHeight)) + loop * effect.items.length * lineHeight
          // 只绘制非空行
          if (effect.items[i].trim()) {
            ctx.fillText(effect.items[i], x + padding, textY)
          }
        }
      }

      ctx.restore()
    },

    // 绘制左右文字滚动
    drawMarqueeEffect(ctx, w, h, effect, scale, offsetX, offsetY, previewHeight) {
      const state = this.globalCanvasState

      ctx.save()
      ctx.globalAlpha = effect.opacity / 100

      // 直接在 360x640 坐标系绘制
      const x = effect.left
      const y = 640 - effect.bottom
      const fontSize = effect.fontSize
      const containerWidth = fontSize * 12
      const contentHeight = fontSize * 1.5
      const borderRadius = fontSize * 0.3
      const paddingX = fontSize * 0.8
      const paddingY = fontSize * 0.4

      // DOM 中的容器高度应该是内容高度加上下 padding
      const containerHeight = contentHeight + paddingY * 2

      // 绘制圆角背景 (DOM 中 padding 是包含在容器内部的)
      ctx.beginPath()
      ctx.moveTo(x + borderRadius, y - containerHeight)
      ctx.lineTo(x + containerWidth - borderRadius, y - containerHeight)
      ctx.quadraticCurveTo(x + containerWidth, y - containerHeight, x + containerWidth, y - containerHeight + borderRadius)
      ctx.lineTo(x + containerWidth, y - borderRadius)
      ctx.quadraticCurveTo(x + containerWidth, y, x + containerWidth - borderRadius, y)
      ctx.lineTo(x + borderRadius, y)
      ctx.quadraticCurveTo(x, y, x, y - borderRadius)
      ctx.lineTo(x, y - containerHeight + borderRadius)
      ctx.quadraticCurveTo(x, y - containerHeight, x + borderRadius, y - containerHeight)
      ctx.closePath()
      ctx.fillStyle = effect.backgroundColor
      ctx.fill()

      // 绘制边框
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)'
      ctx.lineWidth = 1
      ctx.stroke()

      // 裁剪区域
      ctx.beginPath()
      ctx.rect(x, y - containerHeight, containerWidth, containerHeight)
      ctx.clip()

      // 设置字体样式
      ctx.font = `${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`

      // 计算所有文字的总宽度
      let totalWidth = 0
      const textWidths = []
      for (const text of effect.items) {
        // 只处理非空行
        if (text.trim()) {
          const width = ctx.measureText(text).width + 40 // 与 DOM 的 padding-right: 40px 对应
          textWidths.push(width)
          totalWidth += width
        } else {
          // 空行也保留一定的宽度
          textWidths.push(40)
          totalWidth += 40
        }
      }

      // 更新滚动偏移 (根据 DOM 动画： animationDuration: 20 / speed，总距离是 totalWidth)
      const animationDuration = 20 / effect.speed // 秒
      const pixelsPerFrame = totalWidth / (animationDuration * 60) // 假设 60fps
      state.hotSaleState.marqueeOffset += pixelsPerFrame

      // 绘制滚动文字
      ctx.fillStyle = effect.color
      ctx.textAlign = 'left'
      ctx.textBaseline = 'middle'

      // 添加文字阴影
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 2
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 1

      let currentX = x + paddingX - (state.hotSaleState.marqueeOffset % totalWidth)

      // 文字垂直居中位置
      const textY = y - paddingY - contentHeight / 2

      // 重复两次以实现无缝滚动
      for (let loop = 0; loop < 2; loop++) {
        for (let i = 0; i < effect.items.length; i++) {
          // 只绘制非空行
          if (effect.items[i].trim()) {
            ctx.fillText(effect.items[i], currentX, textY)
          }
          currentX += textWidths[i]
        }
      }

      ctx.restore()
    },

    // 绘制动态闪烁文字
    drawFlashTextEffect(ctx, w, h, effect, scale, offsetX, offsetY, previewHeight) {
      const state = this.globalCanvasState

      ctx.save()

      // 直接在 360x640 坐标系绘制
      const x = effect.left
      const y = 640 - effect.bottom
      const fontSize = effect.fontSize
      const paddingX = fontSize * 0.8
      const paddingY = fontSize * 0.3

      // 设置字体样式
      ctx.font = `800 ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`

      // 按换行符分割文本
      const lines = effect.text.split('\n')

      // 计算最长一行的宽度作为背景宽度
      let maxTextWidth = 0
      for (const line of lines) {
        const lineWidth = ctx.measureText(line).width
        if (lineWidth > maxTextWidth) {
          maxTextWidth = lineWidth
        }
      }

      // 呼吸动画效果 (与 DOM 动画一致: @keyframes flash-breathing)
      const now = Date.now()
      const duration = 2000 / effect.speed
      const t = (now % duration) / duration

      let scaleAnim = 1
      let alphaAnim = 1

      if (t < 0.5) {
        const progress = t * 2
        scaleAnim = 1 - 0.05 * progress
        alphaAnim = 1 - 0.8 * progress
      } else {
        const progress = (t - 0.5) * 2
        scaleAnim = 0.95 + 0.05 * progress
        alphaAnim = 0.2 + 0.8 * progress
      }

      // 行高
      const lineHeight = fontSize * 1.5
      // 计算总高度
      const totalTextHeight = lines.length * lineHeight

      // 计算背景尺寸 (DOM 中 padding 是包含在容器内部的)
      const bgWidth = maxTextWidth + paddingX * 2
      const bgHeight = totalTextHeight + paddingY * 2
      const borderRadius = fontSize * 0.4

      // 应用缩放动画 (围绕中心)
      ctx.translate(x + bgWidth / 2, y - bgHeight / 2)
      ctx.scale(scaleAnim, scaleAnim)
      ctx.translate(-(x + bgWidth / 2), -(y - bgHeight / 2))

      // 绘制圆角背景
      ctx.beginPath()
      ctx.moveTo(x + borderRadius, y - bgHeight)
      ctx.lineTo(x + bgWidth - borderRadius, y - bgHeight)
      ctx.quadraticCurveTo(x + bgWidth, y - bgHeight, x + bgWidth, y - bgHeight + borderRadius)
      ctx.lineTo(x + bgWidth, y - borderRadius)
      ctx.quadraticCurveTo(x + bgWidth, y, x + bgWidth - borderRadius, y)
      ctx.lineTo(x + borderRadius, y)
      ctx.quadraticCurveTo(x, y, x, y - borderRadius)
      ctx.lineTo(x, y - bgHeight + borderRadius)
      ctx.quadraticCurveTo(x, y - bgHeight, x + borderRadius, y - bgHeight)
      ctx.closePath()
      ctx.fillStyle = effect.backgroundColor
      ctx.globalAlpha = effect.opacity / 100
      ctx.fill()

      // 绘制边框
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)'
      ctx.lineWidth = 1
      ctx.stroke()

      // 绘制文字
      ctx.fillStyle = effect.color
      ctx.textAlign = 'left'
      ctx.textBaseline = 'middle'
      ctx.globalAlpha = alphaAnim * effect.opacity / 100

      // 添加文字阴影
      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 4
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 2

      // 绘制每一行
      for (let i = 0; i < lines.length; i++) {
        const lineY = y - bgHeight + paddingY + i * lineHeight + lineHeight / 2
        // 只绘制非空行
        if (lines[i].trim()) {
          ctx.fillText(lines[i], x + paddingX, lineY)
        }
      }

      ctx.restore()
    },

    // 绘制智能贴片
    drawSmartOverlay(ctx, w, h) {
      const smartOverlayParams = this.$store.state.smartOverlayParams

      if (!smartOverlayParams || !smartOverlayParams.enabled) {
        return
      }

      const state = this.globalCanvasState

      // 预览区域尺寸(手机屏幕)
      const previewWidth = 360
      const previewHeight = 640

      // 计算缩放比例
      const scaleX = w / previewWidth
      const scaleY = h / previewHeight
      // 保持比例一致，取较小值
      const scale = Math.min(scaleX, scaleY)

      // 计算居中偏移
      const offsetX = (w - previewWidth * scale) / 2
      const offsetY = (h - previewHeight * scale) / 2

      ctx.save()
      ctx.translate(offsetX, offsetY)
      ctx.scale(scale, scale)

      // 计算智能贴片位置 (stickerX/Y 是百分比，相对于手机屏幕 360x640)
      // DOM 元素通过 left: X%, top: Y% 定位，我们从那个点开始绘制
      const x = smartOverlayParams.stickerX * (previewWidth / 100)
      const y = smartOverlayParams.stickerY * (previewHeight / 100)

      // 检查是否有即时贴片激活，否则使用当前轮播文字
      let textToDraw = state.smartOverlayState.currentRotationText
      if (state.smartOverlayState.instantStickerActive) {
        textToDraw = state.smartOverlayState.instantStickerValue
      }

      // 如果没有文字，使用默认值
      if (!textToDraw) {
        textToDraw = '爆款推荐'
      }

      console.log('[SmartOverlay Debug - Draw]', {
        canvasWidth: w, canvasHeight: h,
        previewWidth: 360, previewHeight: 640,
        scale, offsetX, offsetY,
        x, y,
        stickerX: smartOverlayParams.stickerX,
        stickerY: smartOverlayParams.stickerY
      })

      // 1. 测量文字宽度来计算贴片宽度
      const mainFontSize = 14
      const tagFontSize = 9
      // 根据实际 DOM 渲染微调行高
      const mainLineHeight = 16 // 稍大于 font-size，匹配实际行高
      const tagLineHeight = 11  // 稍大于 font-size，匹配实际行高

      // 标签文字样式
      ctx.font = '600 ' + tagFontSize + 'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif'
      const sepWidth = ctx.measureText('丨').width
      const anchorTextWidth = ctx.measureText('@主播').width
      const tagTotalWidth = sepWidth + 1 + anchorTextWidth  // 1px margin-right

      // 主要文字样式
      ctx.font = '700 ' + mainFontSize + 'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif'
      const textWidth = ctx.measureText(textToDraw).width

      // 计算最终贴片宽度：取主要文字和标签文字中较大的那个
      const contentWidth = Math.max(textWidth, tagTotalWidth)

      // padding: 4px 10px
      const paddingX = 10
      const paddingY = 4
      const tagMarginBottom = 2

      // 计算高度：
      // - padding-top: 4px
      // - tag height: 9px (line-height: 1)
      // - margin-bottom: 2px
      // - main text height: 14px (line-height)
      // - padding-bottom: 4px
      const stickerWidth = contentWidth + paddingX * 2
      const stickerHeight = paddingY + tagLineHeight + tagMarginBottom + mainLineHeight + paddingY

      const borderRadius = 4

      console.log('[SmartOverlay Debug - Dimensions]', {
        textToDraw,
        tagFontSize, mainFontSize,
        tagLineHeight, mainLineHeight,
        sepWidth, anchorTextWidth, tagTotalWidth, textWidth, contentWidth,
        paddingX, paddingY,
        tagMarginBottom,
        stickerWidth, stickerHeight,
        borderRadius
      })

      // 绘制圆角背景 (带阴影) - 从上往下绘制
      ctx.shadowColor = 'rgba(0, 0, 0, 0.1)'
      ctx.shadowBlur = 8
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 2

      ctx.beginPath()
      ctx.moveTo(x + borderRadius, y)
      ctx.lineTo(x + stickerWidth - borderRadius, y)
      ctx.quadraticCurveTo(x + stickerWidth, y, x + stickerWidth, y + borderRadius)
      ctx.lineTo(x + stickerWidth, y + stickerHeight - borderRadius)
      ctx.quadraticCurveTo(x + stickerWidth, y + stickerHeight, x + stickerWidth - borderRadius, y + stickerHeight)
      ctx.lineTo(x + borderRadius, y + stickerHeight)
      ctx.quadraticCurveTo(x, y + stickerHeight, x, y + stickerHeight - borderRadius)
      ctx.lineTo(x, y + borderRadius)
      ctx.quadraticCurveTo(x, y, x + borderRadius, y)
      ctx.closePath()

      ctx.fillStyle = 'rgba(255, 255, 255, 0.5)'
      ctx.fill()

      // 绘制边框
      ctx.shadowColor = 'transparent'
      ctx.shadowBlur = 0
      ctx.shadowOffsetX = 0
      ctx.shadowOffsetY = 0
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)'
      ctx.lineWidth = 1
      ctx.stroke()

      // 2. 绘制 @主播 标签
      ctx.font = '600 ' + tagFontSize + 'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif'
      ctx.textAlign = 'left'
      ctx.textBaseline = 'top'  // 从顶部开始绘制

      // 标签文字的顶部位置：paddingY + 微调
      const tagTextY = y + paddingY + 1

      // 绘制竖线 (红色)
      ctx.fillStyle = '#fe2c55'
      ctx.fillText('丨', x + paddingX, tagTextY)

      // 绘制 @主播 (黑色, 80% opacity)
      ctx.globalAlpha = 0.8
      ctx.fillStyle = '#000000'
      ctx.fillText('@主播', x + paddingX + sepWidth + 1, tagTextY)
      ctx.globalAlpha = 1  // 恢复不透明度

      // 3. 绘制主要文字
      ctx.font = '700 ' + mainFontSize + 'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif'
      ctx.fillStyle = '#000000'
      ctx.textBaseline = 'top'  // 从顶部开始绘制

      // 主要文字的顶部位置：paddingY + tagLineHeight + tagMarginBottom + 微调
      const mainTextY = y + paddingY + tagLineHeight + tagMarginBottom + 1
      ctx.fillText(textToDraw, x + paddingX, mainTextY)

      ctx.restore()
    },

    // 绘制动态标题
    drawDynamicTitle(ctx, w, h) {
      const dynamicTitleParams = this.$store.state.dynamicTitleParams

      if (!dynamicTitleParams) {
        return
      }

      // 预览区域尺寸(手机屏幕)
      const previewWidth = 360
      const previewHeight = 640

      // 计算缩放比例
      const scaleX = w / previewWidth
      const scaleY = h / previewHeight
      const scale = Math.min(scaleX, scaleY)

      // 计算居中偏移
      const offsetX = (w - previewWidth * scale) / 2
      const offsetY = (h - previewHeight * scale) / 2

      ctx.save()
      ctx.translate(offsetX, offsetY)
      ctx.scale(scale, scale)

      // 绘制第一个标题（仅当主开关打开时）
      if (dynamicTitleParams.enabled && dynamicTitleParams.firstTitleText && dynamicTitleParams.firstTitleText.trim()) {
        this.drawDynamicTitleItemDirect(
            ctx,
            dynamicTitleParams.firstTitleText,
            dynamicTitleParams.firstTitleBg,
            dynamicTitleParams.firstTitleBgOpacity,
            dynamicTitleParams.firstTitleColor,
            dynamicTitleParams.firstTitleShadow,
            dynamicTitleParams.firstTitleSize,
            700, // fontWeight
            dynamicTitleParams.firstTitleLetterSpacing,
            dynamicTitleParams.title1Pos.x,
            dynamicTitleParams.title1Pos.y,
            12, // paddingX - 增大一点更明显
            6   // paddingY - 增大一点更明显
        )
      }

      // 绘制第二个标题（仅当主开关打开时）
      if (dynamicTitleParams.enabled && dynamicTitleParams.secondTitleText && dynamicTitleParams.secondTitleText.trim()) {
        this.drawDynamicTitleItemDirect(
            ctx,
            dynamicTitleParams.secondTitleText,
            dynamicTitleParams.secondTitleBg,
            dynamicTitleParams.secondTitleBgOpacity,
            dynamicTitleParams.secondTitleColor,
            dynamicTitleParams.secondTitleShadow,
            dynamicTitleParams.secondTitleSize,
            600, // fontWeight
            dynamicTitleParams.secondTitleLetterSpacing,
            dynamicTitleParams.title2Pos.x,
            dynamicTitleParams.title2Pos.y,
            10, // paddingX - 增大一点更明显
            5  // paddingY - 增大一点更明显
        )
      }

      // 绘制第三个标题（仅当主开关打开时）
      if (dynamicTitleParams.enabled && dynamicTitleParams.thirdTitleText && dynamicTitleParams.thirdTitleText.trim()) {
        this.drawDynamicTitleItemDirect(
            ctx,
            dynamicTitleParams.thirdTitleText,
            dynamicTitleParams.thirdTitleBg,
            dynamicTitleParams.thirdTitleBgOpacity,
            dynamicTitleParams.thirdTitleColor,
            dynamicTitleParams.thirdTitleShadow,
            dynamicTitleParams.thirdTitleSize,
            500, // fontWeight
            dynamicTitleParams.thirdTitleLetterSpacing,
            dynamicTitleParams.title3Pos.x,
            dynamicTitleParams.title3Pos.y,
            10, // paddingX - 增大一点更明显
            5  // paddingY - 增大一点更明显
        )
      }

      // 绘制装饰元素（始终显示）
      if (dynamicTitleParams.decorations && dynamicTitleParams.decorations.length > 0) {
        dynamicTitleParams.decorations.forEach(dec => {
          this.drawDecorationItemDirect(ctx, dec)
        })
      }

      ctx.restore()
    },

    // 绘制单个动态标题项 - 直接在 360x640 坐标系绘制
    drawDynamicTitleItemDirect(ctx, text, bgColor, bgOpacity, textColor, shadowColor, fontSize, fontWeight, letterSpacing, xPos, yPos, paddingX, paddingY) {
      ctx.save()

      // 计算位置
      const x = xPos
      const y = yPos

      // 计算样式
      const borderRadius = 4
      const lineHeight = fontSize * 1.2

      // 设置字体 - 使用支持 Emoji 的字体
      ctx.font = `${fontWeight} ${fontSize}px system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif`
      ctx.textAlign = 'left'
      ctx.textBaseline = 'middle'

      // 如果有字间距，需要逐字符绘制，否则直接绘制整个字符串
      if (letterSpacing === 0) {
        // 没有字间距，直接绘制整个字符串
        const textWidth = ctx.measureText(text).width
        const bgWidth = textWidth + paddingX * 2
        const bgHeight = lineHeight + paddingY * 2

        // 解析背景颜色
        const r = parseInt(bgColor.slice(1, 3), 16)
        const g = parseInt(bgColor.slice(3, 5), 16)
        const b = parseInt(bgColor.slice(5, 7), 16)
        const a = bgOpacity / 100

        // 绘制圆角背景（无阴影）
        ctx.shadowColor = 'transparent'
        ctx.shadowBlur = 0
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 0

        ctx.beginPath()
        ctx.moveTo(x + borderRadius, y)
        ctx.lineTo(x + bgWidth - borderRadius, y)
        ctx.quadraticCurveTo(x + bgWidth, y, x + bgWidth, y + borderRadius)
        ctx.lineTo(x + bgWidth, y + bgHeight - borderRadius)
        ctx.quadraticCurveTo(x + bgWidth, y + bgHeight, x + bgWidth - borderRadius, y + bgHeight)
        ctx.lineTo(x + borderRadius, y + bgHeight)
        ctx.quadraticCurveTo(x, y + bgHeight, x, y + bgHeight - borderRadius)
        ctx.lineTo(x, y + borderRadius)
        ctx.quadraticCurveTo(x, y, x + borderRadius, y)
        ctx.closePath()

        ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a})`
        ctx.fill()

        // 绘制边框（无阴影）
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)'
        ctx.lineWidth = 1
        ctx.stroke()

        // 绘制文字 - 整体绘制，避免 Emoji 问题
        ctx.fillStyle = textColor

        // 解析阴影颜色（格式如 #000000）
        const shadowR = parseInt(shadowColor.slice(1, 3), 16)
        const shadowG = parseInt(shadowColor.slice(3, 5), 16)
        const shadowB = parseInt(shadowColor.slice(5, 7), 16)
        ctx.shadowColor = `rgba(${shadowR}, ${shadowG}, ${shadowB}, 0.8)`
        ctx.shadowBlur = 4
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 2

        const textY = y + bgHeight / 2
        ctx.fillText(text, x + paddingX, textY)
      } else {
        // 有字间距，逐字符绘制
        let totalWidth = 0
        for (let i = 0; i < text.length; i++) {
          const charWidth = ctx.measureText(text[i]).width
          totalWidth += charWidth
          if (i < text.length - 1) {
            totalWidth += letterSpacing
          }
        }

        // 计算背景尺寸
        const bgWidth = totalWidth + paddingX * 2
        const bgHeight = lineHeight + paddingY * 2

        // 解析背景颜色
        const r = parseInt(bgColor.slice(1, 3), 16)
        const g = parseInt(bgColor.slice(3, 5), 16)
        const b = parseInt(bgColor.slice(5, 7), 16)
        const a = bgOpacity / 100

        // 绘制圆角背景（无阴影）
        ctx.shadowColor = 'transparent'
        ctx.shadowBlur = 0
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 0

        ctx.beginPath()
        ctx.moveTo(x + borderRadius, y)
        ctx.lineTo(x + bgWidth - borderRadius, y)
        ctx.quadraticCurveTo(x + bgWidth, y, x + bgWidth, y + borderRadius)
        ctx.lineTo(x + bgWidth, y + bgHeight - borderRadius)
        ctx.quadraticCurveTo(x + bgWidth, y + bgHeight, x + bgWidth - borderRadius, y + bgHeight)
        ctx.lineTo(x + borderRadius, y + bgHeight)
        ctx.quadraticCurveTo(x, y + bgHeight, x, y + bgHeight - borderRadius)
        ctx.lineTo(x, y + borderRadius)
        ctx.quadraticCurveTo(x, y, x + borderRadius, y)
        ctx.closePath()

        ctx.fillStyle = `rgba(${r}, ${g}, ${b}, ${a})`
        ctx.fill()

        // 绘制边框（无阴影）
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)'
        ctx.lineWidth = 1
        ctx.stroke()

        // 绘制文字 - 逐字符绘制带字间距
        ctx.fillStyle = textColor

        // 解析阴影颜色（格式如 #000000）
        const shadowR = parseInt(shadowColor.slice(1, 3), 16)
        const shadowG = parseInt(shadowColor.slice(3, 5), 16)
        const shadowB = parseInt(shadowColor.slice(5, 7), 16)
        ctx.shadowColor = `rgba(${shadowR}, ${shadowG}, ${shadowB}, 0.8)`
        ctx.shadowBlur = 4
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 2

        const textY = y + bgHeight / 2
        let currentX = x + paddingX

        for (let i = 0; i < text.length; i++) {
          ctx.fillText(text[i], currentX, textY)
          const charWidth = ctx.measureText(text[i]).width
          currentX += charWidth + letterSpacing
        }
      }

      ctx.restore()
    },

    // 绘制装饰元素 - 直接在 360x640 坐标系绘制
    drawDecorationItemDirect(ctx, dec) {
      ctx.save()

      // 处理本地路径
      let src = dec.url
      if (src.startsWith('E:') || src.startsWith('D:')) {
        src = `http://localhost:3000/proxy_image?path=${encodeURIComponent(src)}`
      }

      // 从缓存获取或加载图片
      if (!this.decorationImageCache[src]) {
        const img = new Image()
        img.onload = () => {
          this.decorationImageCache[src] = img
        }
        img.src = src
        this.decorationImageCache[src] = img
      }

      const img = this.decorationImageCache[src]
      if (img && img.complete && img.naturalWidth && img.naturalHeight) {
        // 计算位置
        const x = dec.x
        const y = dec.y
        const width = dec.width
        const height = dec.height

        // 先处理旋转
        if (dec.rotation) {
          const centerX = x + width / 2
          const centerY = y + height / 2

          ctx.translate(centerX, centerY)
          ctx.rotate((dec.rotation * Math.PI) / 180)
          ctx.translate(-centerX, -centerY)
        }

        // 实现 object-fit: contain 效果
        const containerRatio = width / height
        const imgRatio = img.naturalWidth / img.naturalHeight

        let drawWidth, drawHeight
        if (containerRatio > imgRatio) {
          drawHeight = height
          drawWidth = drawHeight * imgRatio
        } else {
          drawWidth = width
          drawHeight = drawWidth / imgRatio
        }

        // 居中绘制图片
        const drawX = x + (width - drawWidth) / 2
        const drawY = y + (height - drawHeight) / 2

        ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight)
      }

      ctx.restore()
    },

    // WebSocket 连接
    connectWebSocket() {
      if (this.globalCanvasState.wsSocket) {
        return
      }

      try {
        const wsUrl = `ws://localhost:3001`
        this.globalCanvasState.wsSocket = new WebSocket(wsUrl)

        this.globalCanvasState.wsSocket.onopen = () => {
          this.globalCanvasState.wsConnected = true
        }

        this.globalCanvasState.wsSocket.onclose = () => {
          this.globalCanvasState.wsConnected = false
          this.globalCanvasState.wsSocket = null

          if (this.globalCanvasState.isVirtualCameraLive) {
            setTimeout(() => this.connectWebSocket(), 2000)
          }
        }

        this.globalCanvasState.wsSocket.onerror = (err) => {
          console.error('[WS] Error:', err)
        }
      } catch (e) {
        console.error('[WS] Connection error:', e)
      }
    },

    // 断开 WebSocket
    disconnectWebSocket() {
      if (this.globalCanvasState.wsSocket) {
        this.globalCanvasState.wsSocket.close()
        this.globalCanvasState.wsSocket = null
        this.globalCanvasState.wsConnected = false
      }
    },

    // 发送 Canvas 帧
    sendCanvasFrame() {
      const state = this.globalCanvasState
      const canvas = this.$refs.globalCanvas

      if (!state.wsConnected || !state.wsSocket || state.isSendingFrame || !canvas) {
        if (!state.wsConnected) {
          this.connectWebSocket()
        }
        return
      }

      state.isSendingFrame = true

      canvas.toBlob((blob) => {
        if (!blob) {
          state.isSendingFrame = false
          return
        }

        const reader = new FileReader()
        reader.onload = () => {
          const arrayBuffer = reader.result
          if (state.wsSocket && state.wsConnected) {
            try {
              state.wsSocket.send(arrayBuffer)
            } catch (e) {
              console.error('[WS] Send failed:', e)
            }
          }
          state.isSendingFrame = false
        }
        reader.readAsArrayBuffer(blob)
      }, 'image/jpeg', 0.6)
    },

    // 开始抖动
    startShake() {
      this.scheduleShake()
    },

    // 停止抖动
    stopShake() {
      if (this.globalCanvasState.shakeTimer) {
        clearTimeout(this.globalCanvasState.shakeTimer)
        this.globalCanvasState.shakeTimer = null
      }
    },

    // 调度抖动 - 参考运镜
    scheduleShake() {
      if (this.globalCanvasState.shakeTimer) clearTimeout(this.globalCanvasState.shakeTimer)
      if (!this.globalCanvasState.shake.enabled) return

      const delay = (this.globalCanvasState.shake.intervalStart +
          Math.random() * (this.globalCanvasState.shake.intervalEnd - this.globalCanvasState.shake.intervalStart)) * 1000

      this.globalCanvasState.shakeTimer = setTimeout(() => this.applyShake(), delay)
    },

    // 应用抖动 - 真正抖动一段时间
    applyShake() {
      this.globalCanvasState.isCurrentlyShaking = true
      const shakeDuration = this.globalCanvasState.shake.mode === 'micro' ? 500 :
          this.globalCanvasState.shake.mode === 'medium' ? 800 : 1200
      setTimeout(() => {
        this.globalCanvasState.isCurrentlyShaking = false
      }, shakeDuration)
      this.scheduleShake()
    },

    // 开始调色
    startColorAdjust() {
      this.scheduleColorAdjust()
    },

    // 停止调色
    stopColorAdjust() {
      if (this.globalCanvasState.effectTimers.colorAdjust) {
        clearTimeout(this.globalCanvasState.effectTimers.colorAdjust)
        delete this.globalCanvasState.effectTimers.colorAdjust
      }
      this.globalCanvasState.colorAdjustState.value = {
        brightness: 1,
        contrast: 1,
        saturation: 1,
        hueRotate: 0
      }
    },

    // 调度调色
    scheduleColorAdjust() {
      if (!this.globalCanvasState.colorAdjust.enabled) return

      const interval = this.globalCanvasState.colorAdjust.adjustStart +
          Math.random() * (this.globalCanvasState.colorAdjust.adjustEnd - this.globalCanvasState.colorAdjust.adjustStart)

      this.globalCanvasState.effectTimers.colorAdjust = setTimeout(() => {
        this.applyColorAdjust()
        this.scheduleColorAdjust()
      }, interval * 1000)
    },

    // 应用调色
    applyColorAdjust() {
      let brightRange, contrastRange, satRange, hueRange
      switch (this.globalCanvasState.colorAdjust.mode) {
        case 'micro':
          brightRange = [0.98, 1.02]
          contrastRange = [0.98, 1.02]
          satRange = [0.95, 1.05]
          hueRange = [-2, 2]
          break
        case 'medium':
          brightRange = [0.94, 1.06]
          contrastRange = [0.94, 1.06]
          satRange = [0.88, 1.12]
          hueRange = [-10, 10]
          break
        case 'heavy':
          brightRange = [0.88, 1.12]
          contrastRange = [0.88, 1.12]
          satRange = [0.8, 1.2]
          hueRange = [-25, 25]
          break
        default:
          brightRange = [1, 1]
          contrastRange = [1, 1]
          satRange = [1, 1]
          hueRange = [0, 0]
      }
      this.globalCanvasState.colorAdjustState.value = {
        brightness: brightRange[0] + Math.random() * (brightRange[1] - brightRange[0]),
        contrast: contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0]),
        saturation: satRange[0] + Math.random() * (satRange[1] - satRange[0]),
        hueRotate: hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
      }
    },

    // 开始AI重组
    startAIRecomposition() {
      // 确保动画状态正确
      const state = this.globalCanvasState
      if (!state.aiAnimState.isAnimating) {
        // 重置from状态为当前状态
        state.aiAnimState.from = {...state.aiAnimState.current}
        // 初始to状态和from一样
        state.aiAnimState.to = {...state.aiAnimState.from}
      }

      this.applyAIRecomposition()
      this.scheduleAIRecomposition()
    },

    // 停止AI重组
    stopAIRecomposition() {
      if (this.globalCanvasState.effectTimers.aiRecomposition) {
        clearTimeout(this.globalCanvasState.effectTimers.aiRecomposition)
        delete this.globalCanvasState.effectTimers.aiRecomposition
      }

      // 重置动画状态
      const state = this.globalCanvasState
      state.aiAnimState.isAnimating = false

      // 重置所有AI重组状态
      state.aiAnimState.from = {
        scale: 1,
        rotate: 0,
        x: 0,
        y: 0,
        brightness: 1,
        contrast: 1,
        saturation: 1,
        hueRotate: 0
      }
      state.aiAnimState.to = {...state.aiAnimState.from}
      state.aiAnimState.current = {...state.aiAnimState.from}

      // 重置其他相关状态（保留兼容性）
      state.currentAIState.value = {
        scale: 1,
        rotate: 0,
        flip: false,
        brightness: 1,
        contrast: 1
      }
      state.aiTransform = {
        scale: 1,
        x: 0,
        y: 0
      }
      state.currentCameraTransform.value = {
        scale: 1,
        x: 0,
        y: 0
      }
    },

    // 开始遮罩视频动画
    startOverlayAnimation() {
      const state = this.globalCanvasState
      if (!state.overlayAnimState.isAnimating) {
        state.overlayAnimState.from = {...state.overlayAnimState.current}
        state.overlayAnimState.to = {...state.overlayAnimState.from}
      }

      this.applyOverlayAnimation()
      this.scheduleOverlayAnimation()
    },

    // 停止遮罩视频动画
    stopOverlayAnimation() {
      if (this.globalCanvasState.overlayAnimTimer) {
        clearTimeout(this.globalCanvasState.overlayAnimTimer)
        this.globalCanvasState.overlayAnimTimer = null
      }

      const state = this.globalCanvasState
      state.overlayAnimState.isAnimating = false

      state.overlayAnimState.from = {
        scale: 1,
        rotate: 0
      }
      state.overlayAnimState.to = {...state.overlayAnimState.from}
      state.overlayAnimState.current = {...state.overlayAnimState.from}

      state.overlayAnimation.scale = 1
      state.overlayAnimation.rotate = 0
    },

    // 调度遮罩视频动画
    scheduleOverlayAnimation() {
      if (!this.globalCanvasState.overlayAnimation.enabled) return

      if (this.globalCanvasState.overlayAnimTimer) {
        clearTimeout(this.globalCanvasState.overlayAnimTimer)
      }

      // 随机间隔 3-8 秒
      const interval = 3000 + Math.random() * 5000

      this.globalCanvasState.overlayAnimTimer = setTimeout(() => {
        this.applyOverlayAnimation()
        this.scheduleOverlayAnimation()
      }, interval)
    },

    // 应用遮罩视频动画
    applyOverlayAnimation() {
      if (this.globalCanvasState.overlayAnimState.isAnimating) {
        return
      }

      const state = this.globalCanvasState

      // 随机缩放范围 0.7-1.5
      const scaleRange = [0.7, 1.5]
      // 随机旋转范围 -360 到 360 度（包含360度旋转）
      const rotateRange = [-360, 360]

      // 设置from为当前状态
      state.overlayAnimState.from = {...state.overlayAnimState.current}

      // 随机生成新的目标状态
      state.overlayAnimState.to = {
        scale: scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0]),
        rotate: rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])
      }

      // 启动动画
      state.overlayAnimState.isAnimating = true
      state.overlayAnimState.startTime = Date.now()
    },

    // 调度AI重组
    scheduleAIRecomposition() {
      if (!this.globalCanvasState.aiRecomposition.enabled) return

      // 清除旧的定时器，避免重复调度
      if (this.globalCanvasState.effectTimers.aiRecomposition) {
        clearTimeout(this.globalCanvasState.effectTimers.aiRecomposition)
      }

      const interval = this.globalCanvasState.aiRecomposition.intervalStart +
          Math.random() * (this.globalCanvasState.aiRecomposition.intervalEnd - this.globalCanvasState.aiRecomposition.intervalStart)

      this.globalCanvasState.effectTimers.aiRecomposition = setTimeout(() => {
        this.applyAIRecomposition()
        this.scheduleAIRecomposition()
      }, interval * 1000)
    },

    // 应用AI重组 - 炫酷科技感效果
    applyAIRecomposition() {
      // 检查是否已有动画在执行
      if (this.globalCanvasState.aiAnimState.isAnimating) {
        return; // 跳过这次，下次再试
      }

      let scaleRange, rotateRange, brightRange, contrastRange, satRange, hueRange, panRange
      switch (this.globalCanvasState.aiRecomposition.mode) {
        case 'micro':
          scaleRange = [1.0, 1.08]
          rotateRange = [-3, 3]
          brightRange = [0.97, 1.03]
          contrastRange = [0.97, 1.03]
          satRange = [0.97, 1.05]
          hueRange = [-15, 15]
          panRange = [-20, 20]
          break
        case 'medium':
          scaleRange = [1.0, 1.22]
          rotateRange = [-18, 18]
          brightRange = [0.85, 1.15]
          contrastRange = [0.85, 1.15]
          satRange = [0.75, 1.3]
          hueRange = [-90, 90]
          panRange = [-70, 70]
          break
        case 'heavy':
          scaleRange = [1.0, 1.32]
          rotateRange = [-30, 30]
          brightRange = [0.75, 1.25]
          contrastRange = [0.75, 1.25]
          satRange = [0.6, 1.5]
          hueRange = [-180, 180]
          panRange = [-100, 100]
          break
        default:
          scaleRange = [1, 1]
          rotateRange = [0, 0]
          brightRange = [1, 1]
          contrastRange = [1, 1]
          satRange = [1, 1]
          hueRange = [0, 0]
          panRange = [0, 0]
      }

      const strategy = Math.floor(Math.random() * 9)

      // 保存当前状态作为from
      const state = this.globalCanvasState
      state.aiAnimState.from = {...state.aiAnimState.current}

      // 根据策略计算目标状态
      let target = {
        scale: 1,
        rotate: 0,
        x: 0,
        y: 0,
        brightness: 1,
        contrast: 1,
        saturation: 1,
        hueRotate: 0
      }

      const mode = this.globalCanvasState.aiRecomposition.mode
      const modeMultiplier = mode === 'micro' ? 0.3 : (mode === 'medium' ? 0.7 : 1.0)

      switch (strategy) {
        case 0:
          // 霓虹脉冲效果：缩放 + 色彩渐变
          target.scale = scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0])
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          break
        case 1:
          // 旋转万花筒：旋转 + 轻微缩放
          target.scale = 1 + (Math.random() * (scaleRange[1] - scaleRange[0])) * 0.6 * modeMultiplier
          target.rotate = (rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])) * 0.8
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          break
        case 2:
          // 赛博朋克：饱和度 + 色相旋转 + 轻微倾斜
          target.scale = scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0]) * 0.5
          target.rotate = (rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])) * 0.3
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          target.x = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.3
          target.y = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.3
          break
        case 3:
          // 数字漂移：平移 + 轻微缩放
          target.scale = 1 + (Math.random() - 0.5) * (scaleRange[1] - scaleRange[0]) * 0.5
          target.rotate = 0
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = 0
          const angle = Math.random() * Math.PI * 2
          const distance = panRange[0] + Math.random() * (panRange[1] - panRange[0])
          target.x = Math.cos(angle) * Math.abs(distance)
          target.y = Math.sin(angle) * Math.abs(distance)
          break
        case 4:
          // 像素故障：多维度组合变化
          target.scale = 1 + (Math.random() * (scaleRange[1] - scaleRange[0])) * 0.4 * modeMultiplier
          target.rotate = (rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])) * 0.5 * modeMultiplier
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          target.x = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.5
          target.y = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.5
          break
        case 5:
          // 霓虹闪烁：缩放 + 对比度
          target.scale = scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0])
          target.rotate = 0
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          target.x = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.2
          target.y = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.2
          break
        case 6:
          // 螺旋扭曲：旋转 + 缩放 + 对角移动
          target.scale = scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0])
          target.rotate = (rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])) * 0.8
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = target.rotate * 2
          const spiralDist = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.6
          target.x = Math.cos(target.rotate * Math.PI / 180) * Math.abs(spiralDist)
          target.y = Math.sin(target.rotate * Math.PI / 180) * Math.abs(spiralDist)
          break
        case 7:
          // 量子波动：随机但整体协调
          target.scale = scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0])
          target.rotate = (rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])) * 0.5
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          target.x = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.7
          target.y = (panRange[0] + Math.random() * (panRange[1] - panRange[0])) * 0.7
          break
        case 8:
          // 星际穿越：缩放 + 色彩
          target.scale = scaleRange[0] + Math.random() * (scaleRange[1] - scaleRange[0])
          target.rotate = (rotateRange[0] + Math.random() * (rotateRange[1] - rotateRange[0])) * 0.5
          target.brightness = brightRange[0] + Math.random() * (brightRange[1] - brightRange[0])
          target.contrast = contrastRange[0] + Math.random() * (contrastRange[1] - contrastRange[0])
          target.saturation = satRange[0] + Math.random() * (satRange[1] - satRange[0])
          target.hueRotate = hueRange[0] + Math.random() * (hueRange[1] - hueRange[0])
          target.x = 0
          target.y = 0
          break
      }

      // 设置目标状态
      state.aiAnimState.to = target

      // 开始动画
      state.aiAnimState.isAnimating = true
      state.aiAnimState.startTime = Date.now()
    },

    // 开始运镜
    startCameraMotion() {
      this.scheduleCameraMotion()
    },

    // 运镜开关过渡动画
    startCameraMotionTransition(enabled) {
      const state = this.globalCanvasState
      const animState = state.cameraMotionAnimState

      // 设置from为当前状态
      animState.from = {...animState.current}

      // 计算目标状态
      const baseScale = 1.1
      if (enabled) {
        // 开启时，目标是基础缩放+运镜
        animState.to = {
          scale: baseScale,
          x: 0,
          y: 0
        }
      } else {
        // 关闭时，目标是原始状态
        animState.to = {
          scale: 1,
          x: 0,
          y: 0
        }
      }

      // 开始动画
      animState.targetEnabled = enabled
      animState.isAnimating = true
      animState.startTime = Date.now()

      // 如果是开启运镜，动画结束后立即开始第一次运镜
      if (enabled) {
        setTimeout(() => {
          this.applyCameraMotion()
        }, animState.duration)
      }
    },

    // 抖动开关过渡动画 - 现在需要缩放过渡了！
    startShakeTransition(enabled) {
      const state = this.globalCanvasState
      const animState = state.shakeAnimState

      animState.targetEnabled = enabled
      animState.isAnimating = true
      animState.startTime = Date.now()
      animState.fromScale = animState.currentScale

      const baseScale = 1.1
      if (enabled) {
        animState.toScale = baseScale
      } else {
        animState.toScale = 1
      }
    },
    // 应用运镜 - 真正运镜一段时间
    applyCameraMotion() {
      const state = this.globalCanvasState

      // 检查是否已经在运镜了，如果是，就跳过这次调度
      if (state.isCurrentlyMoving) {
        console.log('[运镜] 上次运镜还没完成，跳过这次')
        this.scheduleCameraMotion() // 重新调度下一次
        return
      }

      // 计算时间偏移，保证sin和cos的连续性
      const nowReal = Date.now()
      if (state.lastCameraMotionRealEndTime > 0) {
        const realElapsed = (nowReal - state.lastCameraMotionRealEndTime) / 1000
        state.cameraMotionTimeOffset += realElapsed
      }

      state.isCurrentlyMoving = true
      const motionDuration = state.cameraMotion.mode === 'micro' ? 800 :
          state.cameraMotion.mode === 'medium' ? 1200 : 1600
      setTimeout(() => {
        // 运镜结束，保存状态
        state.isCurrentlyMoving = false
        state.lastCameraMotionRealEndTime = Date.now()
      }, motionDuration)
      this.scheduleCameraMotion()
    },

    // 停止运镜
    stopCameraMotion() {
      if (this.globalCanvasState.cameraMotionTimer) {
        clearTimeout(this.globalCanvasState.cameraMotionTimer)
        this.globalCanvasState.cameraMotionTimer = null
      }
      this.globalCanvasState.isCurrentlyMoving = false
      this.globalCanvasState.cameraMotionTimeOffset = 0
      this.globalCanvasState.lastCameraMotionRealEndTime = 0
      this.globalCanvasState.cameraMotionAnimState.current.scale = 1
      this.globalCanvasState.cameraMotionAnimState.current.x = 0
      this.globalCanvasState.cameraMotionAnimState.current.y = 0
      this.globalCanvasState.currentCameraTransform.value = {scale: 1, x: 0, y: 0}
    },

    // 调度运镜
    scheduleCameraMotion() {
      if (this.globalCanvasState.cameraMotionTimer) clearTimeout(this.globalCanvasState.cameraMotionTimer)
      if (!this.globalCanvasState.cameraMotion.enabled) return

      const delay = (Math.floor(Math.random() * (this.globalCanvasState.cameraMotion.motionEnd - this.globalCanvasState.cameraMotion.motionStart + 1)) + this.globalCanvasState.cameraMotion.motionStart) * 1000

      this.globalCanvasState.cameraMotionTimer = setTimeout(() => this.applyCameraMotion(), delay)
    },


    isActive(path) {
      const route = this.$route
      if (path === '/') return this.$route.path === '/'
      return route.path.startsWith(path)
    },

    // 控制 globalVideo 的方法
    setGlobalVideoSrc(url = '') {


      this.pauseGlobalVideo();
      if (this.getGlobalVideo() && this.videoUrl != url) {
        this.videoUrl = url;
        this.getGlobalVideo().src = url;

        if(this.flvGlobalIns){
          this.flvGlobalIns.destroy()
          this.flvGlobalIns=null
        }

        if (url.indexOf("flv") != -1) {
          if (flvjs.isSupported()) {
            this.flvGlobalIns = flvjs.createPlayer({
              type: 'flv',
              url: url,
              isLive: false
            })
            this.flvGlobalIns.attachMediaElement(this.getGlobalVideo())
            this.flvGlobalIns.load()

          }
        }

        this.initVideoCanvas()
      }

    },
    playGlobalVideo() {
      if (this.$refs.globalVideo) {
        return this.getGlobalVideo().play();
      }
    },
    pauseGlobalVideo() {
      if (this.$refs.globalVideo) {
        return this.getGlobalVideo().pause()
      }
    },
    setGlobalVideoCurrentTime(time) {
      if (this.$refs.globalVideo) {
        this.getGlobalVideo().currentTime = time
      }
    },
    setGlobalVideoMuted(muted) {
      if (this.$refs.globalVideo) {
        this.getGlobalVideo().muted = muted
      }
    },
    setGlobalVideoLoop(loop) {
      if (this.$refs.globalVideo) {
        this.getGlobalVideo().loop = loop
      }
    },
    getGlobalAudio() {
      const video = this.getGlobalVideo();
      // 校验DOM是否存在
      if (!video) {
        console.warn("video标签未挂载");
        return null;
      }
      // 全局缓存上下文，只创建一次
      if (!video._audioCtx) {
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          video._audioCtx = new AudioCtx();
        } catch (e) {
          console.error("AudioContext 创建失败", e);
          return null;
        }
        console.log("这是ctx",video)
      }
      const ctx = video._audioCtx;
      // 上下文挂起则尝试恢复
      if (ctx.state === "suspended") {
        ctx.resume().catch(() => {});
      }
      return ctx;
    },
    getGlobalGainNode() {
      const ctx = this.getGlobalAudio();
      if (!ctx) return null;
      const video = this.getGlobalVideo();
      // 不存在就新建增益节点，默认音量1
      if (!video._gainNode) {
        video._gainNode = ctx.createGain();
        video._gainNode.gain.value = 1;
      }
      return video._gainNode;
    },
    getGlobalVideo() {
      return this.globalVideo.video;
    },

    // 控制 overlayVideoPlayer 的方法
    setOverlayVideoSrc(url) {

      this.pauseOverlayVideo();
      if (this.getOverlayVideo() && this.overlayVideoUrl != url) {
        this.getOverlayVideo().src = url;
        this.overlayVideoUrl = url;
      }
      if(this.flvOverlayIns){
        this.flvOverlayIns.destroy()
        this.flvOverlayIns=null
      }

      if (url.indexOf("flv") != -1) {
        if (flvjs.isSupported()) {
          this.flvOverlayIns = flvjs.createPlayer({
            type: 'flv',
            url: url,
            isLive: false
          })
          this.flvOverlayIns.attachMediaElement(this.getOverlayVideo())
          this.flvOverlayIns.load()

        }
      }

    },
    playOverlayVideo() {
      if (this.getOverlayVideo()) {
        return this.getOverlayVideo().play()
      }
    },
    pauseOverlayVideo() {

      if (this.getOverlayVideo()) {
        this.getOverlayVideo().pause()
      }
    },
    getOverlayVideo() {
      return this.overlayVideoPlayer.video;
    },

    // 遮罩视频播放列表管理方法
    setOverlayPlaylist(playlist) {
      this.globalCanvasState.overlayPlaylist = playlist
      this.globalCanvasState.overlayCurrentIndex = 0
      if (playlist.length > 0) {
        this.playOverlayVideoFromPlaylist(0)
      }
    },

    setOverlayPlayMode(mode) {
      this.globalCanvasState.overlay.playMode = mode
    },

    playOverlayVideoFromPlaylist(index) {
      const playlist = this.globalCanvasState.overlayPlaylist
      if (playlist.length === 0) return

      const validIndex = index % playlist.length
      const video = playlist[validIndex]
      const videoUrl = video.path || video.url || video

      this.globalCanvasState.overlayCurrentIndex = validIndex
      this.globalCanvasState.overlayCurrentVideo = video
      this.setOverlayVideoSrc(videoUrl)

      // 设置音频输出设备
      if (this.currentAudioDeviceId) {
        this.$nextTick(() => {
          this.updateAllVideosAudioSinkId(this.currentAudioDeviceId);
        });
      }
    },

    handleOverlayVideoEnded() {
      const state = this.globalCanvasState
      const playlist = state.overlayPlaylist

      if (playlist.length === 0) return

      if (playlist.length === 1) {
        // 单文件模式：播放完毕后从头再开始播放
        this.playOverlayVideoFromPlaylist(0)
      } else {
        // 目录模式：根据播放模式选择下一个
        if (state.overlay.playMode === 'sequence') {
          // 顺序播放：播放下一个，最后一个播放完回到第一个
          const nextIndex = (state.overlayCurrentIndex + 1) % playlist.length
          this.playOverlayVideoFromPlaylist(nextIndex)
        } else {
          // 随机播放：随机选择一个不同的视频
          let randomIndex
          do {
            randomIndex = Math.floor(Math.random() * playlist.length)
          } while (randomIndex === state.overlayCurrentIndex)
          this.playOverlayVideoFromPlaylist(randomIndex)
        }
      }

      // 自动播放下一个视频
      this.$nextTick(() => {
        this.playOverlayVideo()
      })
    },

    // 直播视频播放列表管理方法
    setPlaylist(playlist) {
      this.globalCanvasState.playlist = playlist
      this.globalCanvasState.currentIndex = 0
      if (playlist.length > 0) {
        this.playVideoFromPlaylist(0)
      }
    },

    setPlayMode(mode) {
      this.globalCanvasState.material.playMode = mode
    },

    playVideoFromPlaylist(index) {
      const playlist = this.globalCanvasState.playlist
      if (playlist.length === 0) return

      console.log(playlist)

      const validIndex = index % playlist.length
      const video = playlist[validIndex]
      const videoUrl = video.path || video.url || video

      this.globalCanvasState.currentIndex = validIndex
      this.globalCanvasState.currentVideo = video
      this.setGlobalVideoSrc(videoUrl)

      // 设置音频输出设备
      if (this.currentAudioDeviceId) {
        this.$nextTick(() => {
          this.updateAllVideosAudioSinkId(this.currentAudioDeviceId);
        });
      }
    },

    handleVideoEnded() {
      const state = this.globalCanvasState
      const playlist = state.playlist

      if (playlist.length === 0) return

      if (playlist.length === 1) {
        // 单文件模式：播放完毕后从头再开始播放

        this.playVideoFromPlaylist(0)
      } else {
        // 目录模式：根据播放模式选择下一个
        if (state.material.playMode === 'sequence') {
          // 顺序播放：播放下一个，最后一个播放完回到第一个
          const nextIndex = (state.currentIndex + 1) % playlist.length
          this.playVideoFromPlaylist(nextIndex)
        } else {
          // 随机播放：随机选择一个不同的视频
          let randomIndex
          do {
            randomIndex = Math.floor(Math.random() * playlist.length)
          } while (randomIndex === state.currentIndex)
          this.playVideoFromPlaylist(randomIndex)
        }
      }

      // 自动播放下一个视频
      this.$nextTick(() => {
        this.playGlobalVideo()
      })
    },

    handleVideoError(e) {
      const video = e.target
      if (!video || !video.error) return

      // 忽略正常的中止错误
      const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
      if (isAbort) {
        console.log('[播放器] 忽略中止错误:', video.error)
        return
      }

      console.error('[播放器] 视频加载失败:', {
        src: video.src,
        code: video.error?.code,
        message: video.error?.message
      })

      // 播放出错时自动处理：单文件重试，多文件则换下一个
      const state = this.globalCanvasState
      const playlist = state.playlist

      if (playlist.length === 1) {
        // 单文件模式：出错时重试播放
        console.log('[播放器] 单文件播放出错，重试播放')
        this.playVideoFromPlaylist(0)
        this.$nextTick(() => {
          this.playGlobalVideo()
        })
      } else if (playlist.length > 1) {
        // 目录模式：自动跳过到下一个
        console.log('[播放器] 自动跳过损坏的视频，播放下一个')
        if (state.material.playMode === 'sequence') {
          const nextIndex = (state.currentIndex + 1) % playlist.length
          this.playVideoFromPlaylist(nextIndex)
        } else {
          let randomIndex
          do {
            randomIndex = Math.floor(Math.random() * playlist.length)
          } while (randomIndex === state.currentIndex)
          this.playVideoFromPlaylist(randomIndex)
        }
        // 自动播放
        this.$nextTick(() => {
          this.playGlobalVideo()
        })
      }
    },

    handleOverlayVideoError(e) {
      const video = e.target
      if (!video || !video.error) return

      // 忽略正常的中止错误
      const isAbort = video.error.code === 4 || video.error.message?.includes('ABORT')
      if (isAbort) {
        console.log('[遮罩播放器] 忽略中止错误:', video.error)
        return
      }

      console.error('[遮罩播放器] 视频加载失败:', {
        src: video.src,
        code: video.error?.code,
        message: video.error?.message
      })

      // 播放出错时自动处理：单文件重试，多文件则换下一个
      const state = this.globalCanvasState
      const playlist = state.overlayPlaylist

      if (playlist.length === 1) {
        // 单文件模式：出错时重试播放
        console.log('[遮罩播放器] 单文件播放出错，重试播放')
        this.playOverlayVideoFromPlaylist(0)
        this.$nextTick(() => {
          this.playOverlayVideo()
        })
      } else if (playlist.length > 1) {
        // 目录模式：自动跳过到下一个
        console.log('[遮罩播放器] 自动跳过损坏的视频，播放下一个')
        if (state.overlay.playMode === 'sequence') {
          const nextIndex = (state.overlayCurrentIndex + 1) % playlist.length
          this.playOverlayVideoFromPlaylist(nextIndex)
        } else {
          let randomIndex
          do {
            randomIndex = Math.floor(Math.random() * playlist.length)
          } while (randomIndex === state.overlayCurrentIndex)
          this.playOverlayVideoFromPlaylist(randomIndex)
        }
        this.$nextTick(() => {
          this.playOverlayVideo()
        })
      }
    },

    // 真实摄像头管理方法
    async enumerateRealCameraDevices() {
      try {
        // 先获取用户授权
        const stream = await navigator.mediaDevices.getUserMedia({video: true})
        // 停止流，只是为了获取权限
        stream.getTracks().forEach(track => track.stop())

        // 获取设备列表
        const devices = await navigator.mediaDevices.enumerateDevices()
        // 只过滤视频设备


        this.globalCanvasState.realCameraDevices = devices.filter(device => device.kind === 'videoinput')


        return this.globalCanvasState.realCameraDevices
      } catch (error) {
        console.error('获取摄像头设备失败:', error)
        throw error
      }
    },

    async startRealCamera(deviceId) {
      try {
        const constraints = {
          video: {
            deviceId: deviceId ? {exact: deviceId} : undefined,
            // 让浏览器选择最佳原始分辨率
            width: {ideal: 1920},
            height: {ideal: 1080}
          }
        }

        const stream = await navigator.mediaDevices.getUserMedia(constraints)
        this.globalCanvasState.realCameraStream = stream

        // 绑定到隐藏的视频元素
        if (this.$refs.realCameraVideoElement) {
          this.$refs.realCameraVideoElement.srcObject = stream

          // 监听视频元数据加载完成，获取原始宽高
          this.$refs.realCameraVideoElement.onloadedmetadata = () => {
            if (this.$refs.realCameraVideoElement) {
              this.globalCanvasState.realCameraOriginalWidth = this.$refs.realCameraVideoElement.videoWidth
              this.globalCanvasState.realCameraOriginalHeight = this.$refs.realCameraVideoElement.videoHeight
              console.log('[Camera] 获取到原始摄像头尺寸:',
                  this.globalCanvasState.realCameraOriginalWidth,
                  'x',
                  this.globalCanvasState.realCameraOriginalHeight
              )
            }
          }

          // 确保视频播放
          try {
            await this.$refs.realCameraVideoElement.play()
          } catch (e) {
            console.log('自动播放摄像头失败，可能需要用户交互:', e)
          }
        }

        // 更新全局状态的video引用
        this.$nextTick(() => {
          this.globalCanvasState.realCameraVideo = this.$refs.realCameraVideoElement
        })

        return stream
      } catch (error) {
        console.error('开启摄像头失败:', error)
        throw error
      }
    },

    stopRealCamera() {
      if (this.globalCanvasState.realCameraStream) {
        this.globalCanvasState.realCameraStream.getTracks().forEach(track => track.stop())
        this.globalCanvasState.realCameraStream = null
      }

      if (this.$refs.realCameraVideoElement) {
        this.$refs.realCameraVideoElement.srcObject = null
      }

      this.globalCanvasState.realCameraVideo = null
    }
  }
}
</script>

<style lang="scss">
#app {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.global-video {
  display: none;
}

.sidebar {
  width: 220px;
  min-width: 220px;
  height: 100vh;
  background: var(--bg-surface);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease, min-width 0.3s ease;
  position: relative;
  z-index: 10;
}

.sidebar.collapsed {
  width: 64px;
  min-width: 64px;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 18px;
  border-bottom: 1px solid var(--border);
}

.logo-icon {
  flex-shrink: 0;
}

.logo-text {
  font-family: 'Orbitron', sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  white-space: nowrap;
  color: var(--text-primary);
}

.logo-text .accent {
  color: var(--accent);
}

.sidebar-nav {
  flex: 1;
  padding: 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
}

#vip-time {
  position: absolute;
  bottom: 7px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  background: #161616;
  border-radius: 10px;
  padding: 5px 10px;
  white-space: nowrap;
  text-align: center;
  color: var(--accent);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 13px;
  transition: all 0.2s ease;
  position: relative;
  white-space: nowrap;
  cursor: pointer;
}

.nav-item:hover {
  background: rgba(0, 212, 255, 0.06);
  color: var(--text-primary);
}

.nav-item.active {
  background: rgba(0, 212, 255, 0.1);
  color: var(--accent);
}

.nav-indicator {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 20px;
  background: var(--accent);
  border-radius: 2px;
  box-shadow: 0 0 8px var(--accent-glow);
}

.nav-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.sidebar-bottom {
  padding: 12px;
  border-top: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.collapse-btn {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-secondary);
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.collapse-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.sidebar-version {
  font-size: 11px;
  color: var(--text-muted);
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  padding: 28px 16px;
}

.app-header {
  user-select: none;
  height: 72px;
  min-height: 72px;
  background: rgba(18, 18, 18, 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 100;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.breadcrumb-item {
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.breadcrumb-sep {
  color: var(--text-muted);
}

.breadcrumb-active {
  color: var(--accent);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-stat {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-text {
  font-size: 11px;
  color: var(--success);
  letter-spacing: 1px;
}

.header-time {
  font-size: 12px;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.header-divider {
  width: 1px;
  height: 20px;
  background: var(--border);
  margin: 0 4px;
}

.win-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  width: 30px;
  height: 30px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.win-btn:hover {
  background: rgba(255, 255, 255, 0.06);
  color: var(--text-primary);
}

.win-btn.win-close:hover {
  background: rgba(255, 71, 87, 0.15);
  color: var(--danger);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 212, 255, 0.08);
  border: 1px solid rgba(0, 212, 255, 0.2);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 4px;
}

.user-avatar:hover {
  background: rgba(0, 212, 255, 0.15);
  border-color: var(--accent);
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.15);
}

.overlay-video-element {

  display: none;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  object-fit: fill;
  /* 铺满全屏作为遮罩 */


  pointer-events: none;
  z-index: 4;

}

.globalCanvas {
  display: none;
  width: 1080px;
  height: 1920px;
}

/* 全局 Toast 样式 */
.toast-notification {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  pointer-events: none;
}

.toast-content {
  background: rgba(20, 20, 20, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid #333;
  color: #fff;
  padding: 10px 20px;
  border-radius: 12px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.toast-notification.success .toast-content {
  border-color: #00d4ff;
  color: #00d4ff;
}

.toast-notification.error .toast-content {
  border-color: #ff4757;
  color: #ff4757;
}

.toast-notification.info .toast-content {
  border-color: #00d4ff;
  color: #fff;
}

/* Transition 动画 */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translate(-50%, -20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -40px);
}
</style>
